import { faArrowRightArrowLeft, faCheckDouble, faChevronDown, faChevronRight, faClockRotateLeft, faComment, faDice, faEyeDropper, faFolder, faFolderOpen, faGears, faImage, faPenFancy, faPenToSquare, faPerson, faPlaneUp, faRotate, faScissors, faShapes, faSliders, faTrash, faUpRightAndDownLeftFromCenter, faWandMagicSparkles, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import EffectThemeContainer from "../../effectTheme/effectThemeContainer";
import EffectThemeButton from "../../effectTheme/effectThemeButtons";
import EffectThemeTextarea from "../../effectTheme/effectThemeTextarea";
import EffectThemeDropdown from "../../effectTheme/effectThemeDropdown";
import EffectThemeRange from "../../effectTheme/effectThemeRange";
import EffectThemeInput from "../../effectTheme/effectThemeInput";
import FileUpload from "../../fileupload/fileUpload";
import EffectThemeImageGrid from "./ImageList";
import { useAiImageTypesGeneration } from "../../../hooks/useAiImageTypesGeneration";
import { fileToBase64, urlToFile } from "../../../utils/fileHandling";
import ImageProps, { ColorFilterProps, ImageLayerProps, LayerProps, OverlayRect,SettingPanelProps, SettingsPanelAiEditProps, SettingsPanelCreateInputProps, SettingsPanelEditInputProps, styleImageGeneration } from "../../../types/imageStudio/images";
import {colorFilterList } from "../../../utils/images/colorFilter";
import applyColorFilters, { applySelectedColorTransparency, applySelectedColorTransparencyTransition, flipCanvas, getImageDimensions,} from "../../../utils/images/editFunctions";
import AILogo from "../icons/AILogo";
import { canvasToFile, loadImage } from "../../../utils/images/imagesFunctions";
import { CanvasDisplayRectProps } from "../../../types/imageStudio/layerComponent";
import { AiLayerVariationGenerationProps, ImageGenerationBodyProps, OutPaintGenerationProps, PromptProps } from "../../../types/ai/api";
import { composeImageWithLayers, getImagePixelSize, textLayerToSvgSrc, valueIsAspectRatioType } from "../../../utils/images/imageConvertFormats";
import { drawingLayerPrompt, expandImagePrompt, extractObjectPrompt, improveImageGenerationPrompt, randomImagePromptGenerator, removeObjectPrompt, spellCorrectionPrompt, styleDescriptionPrompt, textLayerPrompt, variationPrompt } from "../../../utils/aiModels/prompts";
import { drawSelectionPath, isLayerProps, mergeLayerAndGetLayerWithSelectionIds, renderLayerToCanvas } from "../../../utils/images/layerFunctions";
import { InfoPopoverButton } from "./InfoButton";
import { AiConvertToImageInfoElement, AiExpandImageWIthVariationsInfoElement, AiGeneralFunctionInfoElement, AiGenerateVariationsInfoElement, AiObjectInfoElement, AiRemoveInfoElement, AiSpellCorrectionInfoElement, AiUpscaleInfoElement, AspectRatioInfoElement, BrightnessInfoElement, CfgInfoElement, ClarityInfoElement, ContrastInfoElement, HighlightsInfoElement, NumberOfImagesInfoElement, NumberOfVariationsInfoElement, PositiveNegativePromptInfoElement, QualityInfoElement, SamplerInfoElement, SamplingStepsInfoElement, SaturationInfoElement, SchedulerInfoElement, SeedInfoElement, ShadowsInfoElement, SharpnessInfoElement, TemperatureInfoElement, TintInfoElement, TransparencyInfoElement, VibranceInfoElement, VignettingInfoElement, WhitenessInfoElement, WorkLoadCreateSettingsInfoElement, WorkLoadEditAIModeInfoElement, WorkLoadEditStandardInfoElement, WorkLoadPromptInfoElement } from "../../../utils/aiModels/infotexts";
import sengiInfo1 from "../../../assets/sengi_info_1.svg";
import sengiInfo2 from "../../../assets/Sengi_info_2.svg";
import sengiInfo3 from "../../../assets/sengi_info_3.svg";
import sengiInfo4 from "../../../assets/sengi_info_4.svg";
import { AiLLMProps, useAiLLM } from "../../../hooks/useAiLLM";
import { renderStyleDropdownItem, styleFilterGroups } from "../../../utils/images/imageStylesList";
import { SengiColors } from "../../../utils/SengiColors";
import { aiStateTypes} from "../../../types/ai/states";
import { ImageCreateProps, ImageCreateResponseProps, ImageToImageEditProps, ImageToImageEditResponseProps } from "../../../types/ai/api";
import { ApiPayment } from "../../../apis/ApiPayment";
import { stripKnownImageStudioExtensions } from "../../../utils/aiModels/apiImageStudio";
import FreeLogo from "../icons/FreeLogo";
import BetaLogo from "../icons/BetaLogo";
import { handleGetRandomNumber } from "../../../utils/calculations";

const stateTimeoutTime = 10000;

export const SettingsPanel = ({
    aiModelList=[],
    preSelectedAiModel,
    image = null,
    switchImageCreateEdit=false,
    switchSettingsAndHistory=true,
    createImageButtonText='Create',
    editImageButtonText='Edit',
    checkPrompt=false,
    checkPromptText='Check Prompt',
    generateRandomPrompt=false,
    generateRandomPromptText='Random Prompt',
    addReferences=false,
    addReferenceText='',
    samplingSteps=false,
    samplerList=[],
    schedulerList=[],
    stylesList=[],
    aspectRatioList=[],
    creativityRange=true,
    seed=true,
    qualityList=[],
    numberGenerationsMax=9,
    numberOfGenerationsText = '',
    historyOfEditedImages,
    canvasRef,
    canvasViewportRef,
    canvasWrapperRef,
    canvasDisplayRect,
    isPickingTransparencyColor = false,
    isPickingTransparencyTransitionColor=false,
    onToggleTransparencyColorPicker,
    onToggleTransparencyTransitionColorPicker,
    pickedTransparencyColor,
    pickedTransparencyTransitionColor,
    cropMode=false,
    rotateMode=false,
    rotationDraft=0,
    isRotating=false,
    selectedLayer=null,
    aiEditReference,
    marqueeArea=false,
    allLayer=[],
    selectedLayerIDs=[],
    layerAreaSelection,
    centerCanvas,
    onTransparencyColorPicked,
    onTransparencyTransitionColorPicked,
    onItemSelect,
    onItemHover,
    onItemHoverEnd,
    onGenerations,
    onCreateNewBaseImageEntry,
    onImageEdited,
    onRotatePreviewChange,
    onToggleCropeMode,
    onToggleRotationMode,
    onChangeRotationDraft,
    onIsRotating,
    handleRotateMove,
    onChangeLayer,
    onChangeBaseImageVariations,
    commitLayerChange, //rebuild and adjust order numbers and fix selected layer,
    buildAiReferenceLayerFromLayer,
    buildAiReferenceLayerFromSelection,
    onCancelExtendImage,
    onOpenExpandBaseTransparent,
    onOpenExpandBaseWithVariations,
    onSaveExtendImage,
    openExtandImage,
    onHandleVariationResult,
    onOpenExpandLayerWithVariations,
    onAiEditInputChange,
    onDeleteSelectedAreaFromLayer,
    onDuplicateSelectedAreaFromLayer,
    onExtractSelectedAreaToNewLayer,
    expandPadding,
    onResetExpandState,
    onReplaceBaseImageDirectly
}:SettingPanelProps): [
    overlayRect: OverlayRect, 
    setOverlayRect: React.Dispatch<React.SetStateAction<OverlayRect>>, 
    activeOverlayBaseRect : CanvasDisplayRectProps | null,
    rectToVisibleCanvasCrop: (r: OverlayRect) => OverlayRect | null, 
    runGeometryEdit: (
            editor: (canvas: HTMLCanvasElement) => void,
            patch?: Partial<SettingsPanelEditInputProps>
        ) => Promise<void>, 
    settingsSideBar: JSX. Element,
    workOnBaseImage: boolean,
    setWorkOnBaseImage: React.Dispatch<React.SetStateAction<boolean>>,
    expandImageVariationsActive: boolean,
    setExpandImageVariationsActive: React.Dispatch<React.SetStateAction<boolean>>,
    flipHorizontal:() => Promise<void>,
    flipVertical:() => Promise<void>,
    openCrop: () => void,
    aiGenerationsState: aiStateTypes,
    imageEditCosts: ImageToImageEditResponseProps | null,
    handleGenerateVariations: (type: 'generateVariationsImage' | 'expanding' | 'removeBackground' | 'removeObject' | 'extractObject'| 'extractAndRemoveObject' | 'extractPose' | 'imageUpscale-2x' | 'imageUpscale-4x' | 'convertToImage' | 'spellCorrection', target: 'layer' | 'base')=> Promise<void>,
] => {
    const { t } = useTranslation('imageStudioSettings');
    const [historyCreate, setHistoryCreate] = useState<SettingsPanelCreateInputProps[]>([]);
    const [historyEdit, setHistoryEdit] = useState<SettingsPanelEditInputProps[]>([]);
    const [aiFunctionsAreDisabled, setAiFunctionsAreDisabled] = useState(false);
    const [aiGenerationIsRunning, setAiGenerationIsRunning] = useState(false);
    const [expandImageVariationsActive, setExpandImageVariationsActive] = useState(false);
    const [imageCreationCost, setImageCreationsCost] = useState<ImageCreateResponseProps| null>(null);
    const [imageEditCosts, setImageEditCosts] = useState<ImageToImageEditResponseProps | null>(null);
    
    const lastLocallyEditedSrcRef = useRef<string>('');
    const pendingExtractAndRemoveFillRef = useRef<AiLayerVariationGenerationProps | null>(null);
    const previewTokenRef = useRef(0);

    const [rotationInputValue, setRotationInputValue] = useState<number>(0);
    const [inputCreate,setInputCreate] =useState<SettingsPanelCreateInputProps>({
        prompt_positive: '',
        prompt_negative: '',
        selectedAiModel: preSelectedAiModel ?? aiModelList.length > 0 ? aiModelList[0] : '',
        aspectRatio: aspectRatioList  && aspectRatioList.length > 0 ? aspectRatioList[0] : '1:1 (quadratic)',
        style: 'none',
        samplingSteps: 12,
        creativity: 2.5,
        sampler: samplerList && samplerList.length > 0 ? samplerList[0] : 'euler',
        seed: 42,
        numberGenerations: 1,
        scheduler: schedulerList && schedulerList.length > 0 ? schedulerList[0] : 'simple',
        quality: 'Standard',
        generation: null,
        reference: null
    });
    const [inputEdit, setInputEdit] = useState<SettingsPanelEditInputProps>({
        aspectRatio: '1:1',
        colorFilterName: 'No Filter',
        colorFilterData: colorFilterList[0],
        flipHorizontal: false,
        flipVertical: false,
        rotation: 0,
        cropRect: null,
        originalImgSrc: image?.src ?? '',
        baseImgSrc: image?.src ?? '',
        imgSrc: image?.src ?? '',
        imgFile: null,
        thumbnail: null,
        createdAt: new Date(),
        width: image?.width ?? 0,
        height: image?.height ?? 0,
        title: image?.title ?? '',
        transparency: {
            color: '#ffffff',
            alpha: 1,
            tolerance: 40
        },
        transparencyTransition: {
            color: '#ffffff',
            alpha: 1,
            tolerance: 40
        }
    });
    const [inputAiEdit, setInputAiEdit] = useState<SettingsPanelAiEditProps>({
        prompt_positive: '',
        prompt_negative: '',
        selectedAiModel: preSelectedAiModel ?? aiModelList.length > 0 ? aiModelList[0] : '',
        samplingSteps: 12,
        creativity: 2.5,
        sampler: samplerList && samplerList.length > 1 ? samplerList[0] : 'Euler',
        seed: 42,
        numberGenerations: 6,
        scheduler: schedulerList && schedulerList.length > 1 ? schedulerList[0] : 'simple',
        reference: null,
        style: 'none'
    });
    const defaultAiEditPreviewImages: ImageLayerProps[] = aiEditReference
        ? "src" in aiEditReference.content
            ? [aiEditReference.content]
            : "imageEdit" in aiEditReference.content && aiEditReference.content.imageEdit
                ? [aiEditReference.content.imageEdit]
                : "imageData" in aiEditReference.content && aiEditReference.content.imageData
                    ? [aiEditReference.content.imageData]
                    : "drawingData" in aiEditReference.content && aiEditReference.content.drawingData?.rasterSrc
                        ? [{
                            file: null,
                            src: aiEditReference.content.drawingData.rasterSrc,
                            width: aiEditReference.content.width,
                            height: aiEditReference.content.height,
                            timeOfUse: new Date(),
                            title: "Drawing selection"
                        }]
                        : []
        : [];

    const [markedReferencePreview, setMarkedReferencePreview] = useState<ImageLayerProps[] | null>(null);

    const aiEditPreviewImages = markedReferencePreview ?? defaultAiEditPreviewImages;

    // NOTE: wrapper ref is provided by ImageStudio so we can draw overlays over the visible canvas
    const internalWrapperRef = useRef<HTMLDivElement>(null);
    const wrapperRef = canvasWrapperRef ?? internalWrapperRef;
    const viewportRef = canvasViewportRef ?? wrapperRef;
    const inputEditRef = useRef(inputEdit);

    //get actual wrapper sizes
    
    const getVisibleCanvasBoundsInWrapper = () => {
        const canvas = canvasRef?.current;
        const wrapper = wrapperRef.current;
        const viewport = viewportRef.current;

        if (!canvas || !wrapper || !viewport) return null;

        const canvasRect = canvas.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();
        const viewportRect = viewport.getBoundingClientRect();

        const visibleLeft = Math.max(canvasRect.left, viewportRect.left);
        const visibleTop = Math.max(canvasRect.top, viewportRect.top);
        const visibleRight = Math.min(canvasRect.right, viewportRect.right);
        const visibleBottom = Math.min(canvasRect.bottom, viewportRect.bottom);

        const visibleWidth = visibleRight - visibleLeft;
        const visibleHeight = visibleBottom - visibleTop;

        if (visibleWidth <= 0 || visibleHeight <= 0) return null;

        return {
            left: visibleLeft - wrapperRect.left,
            top: visibleTop - wrapperRect.top,
            width: visibleWidth,
            height: visibleHeight,

            fullCanvasLeftInWrapper: canvasRect.left - wrapperRect.left,
            fullCanvasTopInWrapper: canvasRect.top - wrapperRect.top,
            fullCanvasDisplayWidth: canvasRect.width,
            fullCanvasDisplayHeight: canvasRect.height
        };
    };
    
    const cropDisplayRect = getVisibleCanvasBoundsInWrapper();
    
    const [overlayRect, setOverlayRect] = useState<OverlayRect>({ x: 0.1, y: 0.1, w: 0.8, h: 0.8 });
    const activeOverlayBaseRect =
        cropMode
            ? cropDisplayRect
            : canvasDisplayRect;
    
    const openCrop = () => {
        //avoid cropping while rotate or expand
        if (rotateMode || openExtandImage?.active) return;
        onToggleRotationMode?.(false);
        onToggleCropeMode?.(true);
        onCancelExtendImage();
        setOverlayRect({ x: 0.1, y: 0.1, w: 0.8, h: 0.8 });
    };
    const openRotate = (initial: number) => {
        //avoid rottaing whil cropping or expanding
        if (cropMode || openExtandImage?.active) return;
        onToggleCropeMode?.(false);
        onToggleRotationMode?.(true);
        onCancelExtendImage();
        onChangeRotationDraft?.(typeof initial === "number" ? initial : inputEdit.rotation);
    };

    const [positiveAndNegativePrompt,setPositiveAndNegativePrompt] = useState(false);
    const [positiveAndNegativePromptEdit,setPositiveAndNegativePromptEdit] = useState(false);

    const [settingsActive, setSettingsActive] = useState<boolean>(true);
    const [creatingActive,setCreatingActiv] = useState<boolean>(true);
    const [showEditStandardFunctions, setShowEditStandardFunction] = useState<boolean>(true)

    //Edit image functions
    const [colorFilter,setColorFilter] = useState<ColorFilterProps>(colorFilterList[0])

    //accordions
    const [showPrompt, setShowPrompt] = useState(true);
    const [showPromptSettingsAdvancedCreate, setShowPromptSettingsAdvancedCreate] = useState(false);

    const [showImagePropSettings, setShowImagePropsSettings] = useState(true);
    // const [showUploadImageEdit, setShowUploadImageEdit] = useState<boolean>(false);
    const [showSpecificFilterEdit, setShowSpecificFilterEdit] = useState(false);
    const [showTransparancyEdit, setShowTransparencyEdit] = useState(false);

    const [showBasicAIFunctions, setShowBasicAIFunctions] = useState<boolean>(image == null);
    const [showSettingsAdvancedAIFunctions, setShowSettingsAdvancedAIFunctions] = useState(false);

    const [switchUseBaseImageAsReferenceAiEdit, setSwitchUseBaseImageAsReferenceAiEdit] = useState(true);
    const [switchUseAllLayersAsReferenceAiEdit, setSwitchUseAllLayersAsReferenceAiEdit] = useState(false);
    const [switchUseAllSelectedLayersAsReferenceAiEdit, setSwitchUseAllSelectedLayersAsReferenceAiEdit] = useState(false);
    const [generation,state,setState,getJobID,insufficientCreditsDialogCreate] = useAiImageTypesGeneration();
    const [generationAiEdit,stateAiEdit,setStateAiEdit,startNewJob,insufficientCreditsDialogEdit] = useAiImageTypesGeneration();
    const [generationLLM,stateLLM,setStateLLM,sendMessage,insufficientCreditsDialogLLM] = useAiLLM();
    const [llmResponseType, setLLMResponseType] = useState<'create'|'edit' | 'spellCorrection' |null>(null);
    const [aiGenerationsState, setAiGenerationsState] = useState<aiStateTypes>(null);

    const [workOnBaseImage, setWorkOnBaseImage] = useState(false);
    const [seedRandomCreateActive, setSeedRandomCreateActive] = useState(true);
    const [seedRandomEditActive, setSeedRandomEditActive] = useState(true);

    //COST CALCULATIONS
    const updateImageCreationCosts = async() => {
        const imageDimension = getImagePixelSize(valueIsAspectRatioType(inputCreate.aspectRatio) ?  inputCreate.aspectRatio: '1:1 (quadratic)', inputCreate.quality);
        try{
            let dataObject: ImageCreateProps = {
                imgWidth: imageDimension.width,
                imgHeight: imageDimension.height,
                numberOfGenerations: inputCreate.numberGenerations,
                samplingSteps: inputCreate.samplingSteps,
                cfg: inputCreate.creativity,
                sampler: inputCreate.sampler,
                scheduler: inputCreate.scheduler,
                model: inputCreate.selectedAiModel,
                reference: inputCreate.reference 
                    ?   {
                            width: inputCreate.reference.width,
                            height: inputCreate.reference.height
                        }
                    : null
            }
            await ApiPayment.GetCostsForImageCreate(dataObject)
            .then((response)=>{
                setImageCreationsCost(response);
            })
            .catch(()=>{
                console.log('Error in calculation creation costs.');
            });
        }
        catch{
            console.log('Error in calculation creation costs.');
        }
    };
    const updateImageEditCosts = async() => {
        if(!aiEditReference || !aiEditReference.content){return;}
        const typeData = inputAiEdit.reference && isLayerProps(inputAiEdit.reference.content)
            ? inputAiEdit.reference.content.type === 'text'
                ? 'text'
                : inputAiEdit.reference.content.type === 'drawings'
                    ? 'drawing'
                    : 'image'
            : 'image'
        try{
            let responseImageDimension = {
                width: expandPadding && expandImageVariationsActive 
                    ? aiEditReference.content.width + expandPadding.left + expandPadding.right
                    : aiEditReference.content.width,
                height: expandPadding && expandImageVariationsActive 
                    ? aiEditReference.content.height + expandPadding.top + expandPadding.bottom
                    : aiEditReference.content.height,
            }
            let dataObject: ImageToImageEditProps= {
                imgWidth: responseImageDimension.width,
                imgHeight: responseImageDimension.height,
                numberOfGenerations: inputAiEdit.numberGenerations,
                samplingSteps: inputAiEdit.samplingSteps,
                cfg: inputAiEdit.creativity,
                sampler: inputAiEdit.sampler,
                scheduler: inputAiEdit.scheduler,
                model: inputAiEdit.selectedAiModel,
                reference: inputAiEdit.reference 
                    ?   {
                            width: aiEditReference.content.width,
                            height: aiEditReference.content.height
                        }
                    : null,
                type: typeData
            }
            await ApiPayment.GetCostsForImageToImageEdit(dataObject)
            .then((response)=>{
                setImageEditCosts(response);
            })
            .catch(()=>{
                console.log('Error in calculation creation costs.');
            });
        }
        catch{
            console.log('Error in calculation creation costs.');
        }
    };

    //FUNCTIONS PROMPTS
    const handleCheckPrompt = async (type: 'create' | 'edit') => {
        setState(null);
        setStateAiEdit(null);
        setStateLLM('send');
        setLLMResponseType(type);
        setAiGenerationIsRunning(true);
        const inputPositive: string = type === 'create' ? inputCreate.prompt_positive : inputAiEdit.prompt_positive;
        const inputNegative: string | null = type === 'create' ? inputCreate.prompt_negative : inputAiEdit.prompt_negative;
        const prompt = improveImageGenerationPrompt(inputPositive,inputNegative, type);
        const body: AiLLMProps = {
            model:"gpt-oss:20b",
            messages: [{role: 'user', content: prompt}]
        };
        let path = 'chat';
        sendMessage(path,body,true); 
    };
    const handleRandomPrompt = async (type: 'create' | 'edit') => {
        setState(null);
        setStateAiEdit(null);
        setStateLLM('send');
        setLLMResponseType(type);
        setAiGenerationIsRunning(true);
        const prompt = randomImagePromptGenerator(positiveAndNegativePrompt, type);
        const body: AiLLMProps = {
            model:"gpt-oss:20b",
            messages: [{role: 'user', content: prompt}]
        };
        let path = 'chat';
        sendMessage(path,body,true);      
    };
    const parsePromptResponse = (value: unknown): PromptProps | null => {
        try {
            return typeof value === "string"
                ? JSON.parse(value) as PromptProps
                : value as PromptProps;
        } catch (err) {
            console.error("Could not parse generationLLM:", value, err);
            return null;
        }
    };

    //FUNCTIONS CREATE
    const handleTextareaChangeCreate = (event:ChangeEvent<HTMLTextAreaElement>) => {
        const value = event.target.value;
        const name = event.target.name;
        setInputCreate(prev => ({...prev,[name]: value}));
    };
    const handleRangeChangeCreate = (name: string, value: number) => {
        setInputCreate(prev => ({ ...prev, [name]: value }));
    };
    const handleDropdownChangeCreate = (name: string, value: string) => {
        setInputCreate(prev => ({
            ...prev,
            [name]: value,
        }));
        //set same style in edit ai mode
        if(name === 'style'){
            setInputAiEdit(prev => ({
                ...prev,
                [name]: value as styleImageGeneration
            }));
        }
    };
    
    const handleGenerationResult = async() => {
        let generationList: ImageProps[] = [];
        let thumbnail: File | null = null;
        for(const [index, img] of generation.entries()){
            let imgSrc = img.replaceAll('\\','/');
            let imgFile = await urlToFile(img,`${imgSrc.split('/').slice(-1)[0]}-${crypto.randomUUID()}`);
            // cProxy download URLs require an Authorization header a plain <img>/canvas src can't
            // send (fail-closed since 2026-07-14, see TASKS.md) - use a blob: URL derived from the
            // already-authenticated fetch above, never the raw remote URL.
            const blobSrc = URL.createObjectURL(imgFile);
            const imageDimension = await getImageDimensions(imgFile);
            //upload in storage
            thumbnail = await onCreateNewBaseImageEntry(imgFile);
            if(index===0){
                let newEditInput: SettingsPanelEditInputProps = {
                    originalImgSrc: blobSrc,
                    imgSrc: blobSrc,
                    baseImgSrc: blobSrc,
                    imgFile: imgFile,
                    width: imageDimension.width,
                    height: imageDimension.height,
                    aspectRatio: '',
                    colorFilterName: 'No Filter',
                    colorFilterData: colorFilterList[0],
                    flipVertical: false,
                    flipHorizontal: false,
                    rotation:0,
                    title: imgFile.name,
                    transparency: {
                        color: '#ffffff',
                        alpha:1.0,
                        tolerance: 40
                    },
                    thumbnail: thumbnail,
                    createdAt: new Date(),
                    transparencyTransition: {
                        color: '#ffffff',
                        alpha:1.0,
                        tolerance: 40
                    },
                    cropRect: null
                };
                setHistoryEdit([newEditInput]);
            }
            let item: ImageProps = {
                'src': blobSrc,
                'file': imgFile,
                'width': imageDimension.width,
                'height': imageDimension.height,
                'timeOfUse': new Date()
            }
            generationList.push(item);
        }
        let currentInputs = {...inputCreate};
        currentInputs.generation = generationList;
        //set random seed if active for next generation
        if(seedRandomCreateActive){
            currentInputs.seed = handleGetRandomNumber();
        }
        //update inputs
        setInputCreate(currentInputs);
        setExpandImageVariationsActive(false);
        let currentHistory = [...historyCreate];
        currentHistory.push(currentInputs);
        setHistoryCreate(currentHistory);
        //callback to studio
        onGenerations?.(generationList);
        setAiGenerationIsRunning(false);
    };
    const generateImage = async() => {
        setState(null);
        setAiGenerationIsRunning(true);
        if(inputCreate.reference && inputCreate.reference.file){
            let path = 'generate/image-to-image-edit'
            const base64Image = await fileToBase64(inputCreate.reference.file);
            setState('send');
            const imageDimension = getImagePixelSize(valueIsAspectRatioType(inputCreate.aspectRatio) ?  inputCreate.aspectRatio: '1:1 (quadratic)', inputCreate.quality);
            // extrend prompt with style
            const prompt = styleDescriptionPrompt(inputCreate.prompt_positive,inputCreate.prompt_negative, inputCreate.style, true);
            
            const body: ImageGenerationBodyProps = {
                positive_prompt: prompt.positive_prompt, 
                negative_prompt: inputCreate.prompt_negative ? prompt.negative_prompt : undefined,
                image: base64Image,
                width: imageDimension.width,
                height: imageDimension.height,
                seed: inputCreate.seed,
                steps: inputCreate.samplingSteps,
                scheduler: inputCreate.scheduler,
                model: 'Qwen_Image_Edit',
                cfg: inputCreate.creativity,
                number_of_images: inputCreate.numberGenerations,
                sampler: inputCreate.sampler
            }
            try {
                getJobID('image_gen',path,body)
            } catch(err){
                setState('error');
                setAiGenerationIsRunning(false);
            };
        }
        else{
            let path = 'generate/image';
            setState('send');
            const imageDimension = getImagePixelSize(valueIsAspectRatioType(inputCreate.aspectRatio) ?  inputCreate.aspectRatio: '1:1 (quadratic)', inputCreate.quality ?? 'standard');
            const prompt = styleDescriptionPrompt(inputCreate.prompt_positive,inputCreate.prompt_negative, inputCreate.style, false);

            const body: ImageGenerationBodyProps = {
                positive_prompt: prompt.positive_prompt, 
                negative_prompt: inputCreate.prompt_negative ? prompt.negative_prompt : undefined,
                width: imageDimension.width,
                height: imageDimension.height,
                seed: inputCreate.seed,
                steps: inputCreate.samplingSteps,
                scheduler: inputCreate.scheduler,
                model: 'Qwen_Image',
                cfg: inputCreate.creativity,
                number_of_images: inputCreate.numberGenerations,
                sampler: inputCreate.sampler
            }
            try {
                getJobID('image_gen',path,body)
            } catch(err){
                setState('error');
                setAiGenerationIsRunning(false)
            };
        }
    };

    //FUNCTIONS AI EDIT GENERATION
    const getNextLayerID = () => {
        if(allLayer.length > 0){
            let ids = allLayer.map(item => Number(item.layerID));
            let lastID = Math.max(...ids);
            return lastID + 1;
        }
        else{
            return 0;
        }
    };
    const replaceAiReferenceDirectly = (
        reference: AiLayerVariationGenerationProps,
        variations: ImageLayerProps[]
    ) => {
        const firstVariation = variations[0];
        if (!firstVariation || !firstVariation.file) return false;

        if (reference.type === "base" && "src" in reference.content) {
            onReplaceBaseImageDirectly?.({
                ...reference.content,
                ...firstVariation,
                src: firstVariation.src,
                file: new File(
                    [firstVariation.file],
                    reference.content.file?.name ?? 'image.png'
                ),
                width: reference.content.width,
                height: reference.content.height,
                timeOfUse: new Date(),
                title: reference.content.title ?? firstVariation.title
            });

            return true;
        }

        if (isLayerProps(reference.content)) {
            const currentLayer = reference.content;

            const nextLayer: LayerProps = {
                ...currentLayer,
                width: firstVariation.width,
                height: firstVariation.height,
                imageData: firstVariation,
                imageEdit: firstVariation,
                variations: [],
                cropRect: null
            };

            onChangeLayer?.(
                allLayer.map(layer =>
                    layer.layerID === currentLayer.layerID
                        ? nextLayer
                        : layer
                )
            );

            return true;
        }

        return false;
    };
    const handleCreateNewLayer = (refLayer: LayerProps, variations: ImageLayerProps[]) => {
        const nextLayerID = getNextLayerID();
        const nextOrderNumber =
            allLayer.length > 0
                ? Number(allLayer[allLayer.length - 1].orderNumber) + 1
                : 0;

        const resultGeometry = (inputAiEdit.reference as any)?.resultGeometry;

        const geometry = resultGeometry ?? {
            position: { x: refLayer.position.x, y: refLayer.position.y },
            width: refLayer.width,
            height: refLayer.height,
            rotation: refLayer.rotation ?? 0
        };

        const newLayer: LayerProps = {
            type: "ai-variation",
            layerID: nextLayerID,
            position: { ...geometry.position },
            width: geometry.width,
            height: geometry.height,
            orderNumber: nextOrderNumber.toString(),
            hidden: false,
            imageData: variations.length > 0 ? variations[0] : undefined,
            imageEdit: variations.length > 0 ? variations[0] : undefined,
            cropRect: null,
            rotation: geometry.rotation,
            flipHorizontal: false,
            flipVertical: false,
            variations
        };

        commitLayerChange([...allLayer, newLayer], [nextLayerID]);
    };
    const getImageLayerProps = async (title: string | null) => {
        let generationList: ImageLayerProps[] = [];
        let idx = 1;
        for(let img of generationAiEdit){
            let imgSrc = img.replaceAll('\\','/');
            let imgFile = await urlToFile(img,imgSrc.split('/').slice(-1)[0]);
            // see handleGenerationResult() above - never use the raw cProxy URL as a display src.
            const blobSrc = URL.createObjectURL(imgFile);
            let imageDimensions = await getImageDimensions(imgFile);
            let item: ImageLayerProps = {
                src: blobSrc,
                file: imgFile,
                width: imageDimensions.width,
                height: imageDimensions.height,
                timeOfUse: new Date(),
                title: title ? `${title}-variation_${idx}` : undefined,
                prompt_positive: inputAiEdit.prompt_positive,
                prompt_negative: inputAiEdit.prompt_negative,
            }
            generationList.push(item);
            idx ++;
        }
        return generationList;
    };
    const runPendingExtractAndRemoveFill = async () => {
        const pendingFillReference = pendingExtractAndRemoveFillRef.current;

        if (!pendingFillReference) return false;

        pendingExtractAndRemoveFillRef.current = null;

        const prompt = removeObjectPrompt(inputAiEdit.prompt_positive);

        await startImageEditJob(
            pendingFillReference,
            prompt.positive,
            prompt.negative,
            inputAiEdit.numberGenerations
        );

        return true;
    };
    const handleVariationGenerationResultEdit = async() => {
        const isBase = inputAiEdit.reference && inputAiEdit.reference.type === 'base' && !inputAiEdit.reference.isMarking;
        let variations = await getImageLayerProps(isBase ? image?.title ? image.title : image?.file?.name ? image.file.name: null : null);
        //handle directly replace for extract object
        const activeReference = inputAiEdit.reference;

        if (activeReference?.replaceDirectly) {
            replaceAiReferenceDirectly(activeReference, variations);
            const pendingWasStarted = await runPendingExtractAndRemoveFill();
            if (pendingWasStarted) {
                return;
            }

            setInputAiEdit(prev => ({
                ...prev,
                reference: null
            }));

            setAiGenerationIsRunning(false);
            return;
        }
        
        //handle base image
        if(isBase){
            onChangeBaseImageVariations(variations);
        }

        //handle layer: new layer if layer was text or drawing or marked are (marquee always creates a layer even if it was on base image)
        else if(inputAiEdit.reference && isLayerProps(inputAiEdit.reference.content)){
            if (inputAiEdit.reference.createNewLayer){
                handleCreateNewLayer(inputAiEdit.reference.content, variations);
            }
            else {
                const currentLayer:LayerProps = {...inputAiEdit.reference.content};
                currentLayer.variations = variations;
                onChangeLayer?.(allLayer.map(item => {
                    if(item.layerID !== currentLayer.layerID){
                        return item;
                    }
                    else {
                        return currentLayer;
                    }
                }));
            }

        }
        // check if extract and remove object was used to handle remove object from original refrence
        const pendingWasStarted = await runPendingExtractAndRemoveFill();

        if (pendingWasStarted) {
            return;
        }

        //reset input reference storage
        setInputAiEdit(prev=>({
            ...prev,
            reference: null,
            seed: seedRandomEditActive ? handleGetRandomNumber() : prev.seed
        }));
        setAiGenerationIsRunning(false);
    };
    const writeLayerOnBaseImage = async (layer: LayerProps[]) => {
        if(!image) return;
        const canvasWithLayer = await composeImageWithLayers(image,layer);
        const imgWithLayer = canvasToFile(canvasWithLayer,'canvasLayerBaseImage');

        return imgWithLayer;
    };
    const handleDifferentAiReference = async (target: 'layer' | 'base') => {
        let content: LayerProps | ImageProps | null = null;
        let createNewLayer = false;
        if(target === 'base'){
            if(layerAreaSelection){
                createNewLayer = true;
                content = await buildAiReferenceLayerFromSelection();
            }
            else{
                content = image;
            }
        }
        else{
            if(layerAreaSelection){
                if (!selectedLayer) return null;
                createNewLayer = true;
                content = await buildAiReferenceLayerFromSelection();
            }
            else{
                if (selectedLayerIDs.length === 1 && selectedLayer) {
                    content = await buildAiReferenceLayerFromLayer(selectedLayer);
                    createNewLayer = selectedLayer.type === 'text' || selectedLayer.type === 'drawings';
                }
                if(selectedLayerIDs.length > 1){
                    //build new layer
                    //avoid selecting hidden layer
                    const selectedLayers = allLayer.filter((l) =>
                        selectedLayerIDs.includes(l.layerID) &&
                        !l.hidden
                    );
                    if (selectedLayers.length < 2) return null;
                    const [mergedLayer, _] = await mergeLayerAndGetLayerWithSelectionIds(selectedLayers);
                    content = mergedLayer ? {...mergedLayer} : null;
                }
            }
        }
        if(!content) return null;

        const newAiRefference: AiLayerVariationGenerationProps | null = {
            type: target,
            createNewLayer: createNewLayer,
            isMarking: layerAreaSelection ? true : false,
            content: content
        };

        return newAiRefference;
    };
    const getImageFromAiContent = async (
        content: LayerProps | ImageProps
    ): Promise<File | null> => {
        if ("file" in content) {
            return content.file ?? null;
        }

        if ("imageEdit" in content && content.imageEdit?.file) {
            return content.imageEdit.file;
        }

        if ("imageData" in content && content.imageData?.file) {
            return content.imageData.file;
        }

        if ("drawingData" in content && content.drawingData?.rasterSrc) {
            return await urlToFile(content.drawingData.rasterSrc, "drawing_data.png");
        }

        if ("textData" in content && content.textData) {
            return await urlToFile(
                textLayerToSvgSrc(
                    Number(content.width),
                    Number(content.height),
                    content.textData
                ),
                "textlayer_data.svg"
            );
        }

        return null;
    };

    const buildAiReferenceFromLayer = (
        layer: LayerProps,
        type: "layer" | "base",
        createNewLayer: boolean
    ) => {
        return {
            type,
            createNewLayer,
            isMarking: false,
            content: layer
        } as AiLayerVariationGenerationProps;
    };
    const buildAiReferenceFromImage = (
        img: ImageProps,
        createNewLayer = false
    ) => {
        return {
            type: "base",
            createNewLayer,
            isMarking: false,
            content: img
        } as AiLayerVariationGenerationProps;
    };

    const startImageEditJob = async (
        reference: AiLayerVariationGenerationProps,
        positivePrompt: string,
        negativePrompt: string | undefined,
        numberOfImages?: number
    ) => {
        const file = await getImageFromAiContent(reference.content);

        if (!file) {
            setStateAiEdit("error");
            setAiGenerationIsRunning(false);
            return;
        }

        const base64Image = await fileToBase64(file);

        const dataObject: ImageGenerationBodyProps = {
            image: base64Image,
            positive_prompt: positivePrompt,
            negative_prompt: negativePrompt,
            width: reference.content.width,
            height: reference.content.height,
            seed: inputAiEdit.seed,
            steps: inputAiEdit.samplingSteps,
            scheduler: inputAiEdit.scheduler,
            model: `${inputAiEdit.selectedAiModel}_Image_Edit`,
            cfg: inputAiEdit.creativity,
            number_of_images: numberOfImages ?? inputAiEdit.numberGenerations
        };

        setInputAiEdit(prev => ({
            ...prev,
            reference
        }));

        setStateAiEdit("send");
        startNewJob('image_gen', "generate/image-to-image-edit", dataObject);
    };
    const handleGenerateVariations = async(type: 'generateVariationsImage' | 'expanding' |'removeBackground' | 'removeObject' | 'extractObject' | 'extractAndRemoveObject' | 'extractPose' | 'imageUpscale-2x' | 'imageUpscale-4x' | 'convertToImage' | 'spellCorrection', target: 'layer' | 'base')=>{
        let newAiRefference: AiLayerVariationGenerationProps | null = aiEditReference ? {...aiEditReference} : null;
        //handle context menu different target
        if(aiEditReference?.type !== target){
            newAiRefference = await handleDifferentAiReference(target);
        }
        if(!newAiRefference || !image) return;

        //handle expanding after saving and adjust settings
        const hadPendingExpandVariation = expandImageVariationsActive;
        if (type === 'generateVariationsImage' && hadPendingExpandVariation) {
            type = 'expanding';
        }
        if (hadPendingExpandVariation && type !== 'expanding') {
            onResetExpandState?.();
        }
        setExpandImageVariationsActive(false);
        setAiGenerationIsRunning(true);
        setStateAiEdit(null);
        let referenceImage: File | undefined= undefined;
        let dataObject:ImageGenerationBodyProps = {
            image: undefined,
            positive_prompt: inputAiEdit.prompt_positive,
            negative_prompt: inputAiEdit.prompt_negative,
            width: newAiRefference.content.width,
            height: newAiRefference.content.height,
            seed: inputAiEdit.seed,
            steps: inputAiEdit.samplingSteps,
            scheduler: inputAiEdit.scheduler,
            model: inputAiEdit.selectedAiModel,
            cfg: inputAiEdit.creativity,
            number_of_images: inputAiEdit.numberGenerations
        };

        //handle base image
        if(target === 'base'){
            if(switchUseBaseImageAsReferenceAiEdit && image && image.file){
                referenceImage = image.file;
            }
            else if(switchUseAllSelectedLayersAsReferenceAiEdit){
                const selectedLayers = allLayer.filter((item) =>
                    selectedLayerIDs.includes(item.layerID)
                );
                referenceImage = await writeLayerOnBaseImage(selectedLayers);
            }
            else if(switchUseAllLayersAsReferenceAiEdit){
                referenceImage = await writeLayerOnBaseImage(allLayer);
            }
        }
        //handle selected layer
        else{
            if(switchUseAllLayersAsReferenceAiEdit){
                referenceImage = await writeLayerOnBaseImage(allLayer);
            }
            else if(switchUseBaseImageAsReferenceAiEdit && image && image.file){
                referenceImage = image.file;
            }
        }

        //TODO REMOVE VISION MODEL AND ADD REFERENCE DIFFERENTLY
        referenceImage = undefined;

        const file: File | null | undefined= target === 'base' && newAiRefference.type === 'base' && "file" in newAiRefference.content
            ? newAiRefference.content.file
            : "imageData" in newAiRefference.content && newAiRefference.content.imageData
                ? newAiRefference.content.imageData.file
                : "drawingData" in newAiRefference.content && newAiRefference.content.drawingData && newAiRefference.content.drawingData.rasterSrc
                    ? await urlToFile(newAiRefference.content.drawingData.rasterSrc,'drawing_data')
                    : "textData" in newAiRefference.content && newAiRefference.content.textData
                        ? await urlToFile(textLayerToSvgSrc(Number(newAiRefference.content.width),Number(newAiRefference.content.height),newAiRefference.content.textData), "textlayer_data")
                        : null
        if(!file){
            setStateAiEdit('error');
            setAiGenerationIsRunning(false);
            return;
        } 
        const base64Image = await fileToBase64(file);
        const dims = await getImageDimensions(file);
        dataObject.image = base64Image;

        if(type !== 'spellCorrection'){
            setStateAiEdit('send');
        }
        //specific generations need new layer
        const newLayerFunction =
            type === "convertToImage" ||
            type === "extractObject" ||
            type === "extractPose";

        newAiRefference.createNewLayer = newLayerFunction ? true : newAiRefference.createNewLayer;

        const selectionContext = (newAiRefference as any).selectionContext;

        if (newAiRefference.isMarking && selectionContext) {
            if (type === "removeObject") {
                (newAiRefference as any).resultGeometryMode = "source";
                (newAiRefference as any).resultGeometry = selectionContext.sourceLayerGeometry;
            } else {
                (newAiRefference as any).resultGeometryMode = "selection";
                (newAiRefference as any).resultGeometry = null;
            }
        }

        setInputAiEdit(prev => ({
            ...prev,
            reference: newAiRefference
        }));

        const maskWorksOnBaseImage = target === 'base';
        const maskTargetLayer = target === 'layer' ? selectedLayer : null;
        const getCurrentMaskImage = (): ImageLayerProps | ImageProps | null => {
            if (target === "base") {
                return image;
            }

            if (!selectedLayer) return null;

            return selectedLayer.imageEdit ?? selectedLayer.imageData ?? null;
        };
        switch(type){
            case 'convertToImage': {
                let path = 'generate/image-to-image-edit'
                dataObject.model = `${inputAiEdit.selectedAiModel}_Image_Edit`;
                //adjust prompt if text in image
                if("textData" in newAiRefference.content && newAiRefference.content.textData){
                    let textDataPrompt = textLayerPrompt(dataObject.positive_prompt, newAiRefference.content.textData.text);
                    dataObject.positive_prompt = textDataPrompt;
                    //Add style to prompt: only fpr convert to image and generate variaitons
                    const prompt = styleDescriptionPrompt(dataObject.positive_prompt,dataObject.negative_prompt ?? null, inputAiEdit.style,true,true);
                    dataObject.positive_prompt = prompt.positive_prompt;
                    dataObject.negative_prompt = prompt.negative_prompt;
                }
                else if("drawingData" in newAiRefference.content && newAiRefference.content.drawingData){
                    // path = 'generate/image-from-drawing';
                    let drawingDataPrompt = drawingLayerPrompt(dataObject.positive_prompt);
                    dataObject.positive_prompt = drawingDataPrompt;
                    //Add style to prompt: only fpr convert to image and generate variaitons
                    const prompt = styleDescriptionPrompt(dataObject.positive_prompt,dataObject.negative_prompt ?? null, inputAiEdit.style,true);
                    dataObject.positive_prompt = prompt.positive_prompt;
                    dataObject.negative_prompt = prompt.negative_prompt;
                }
                startNewJob('image_gen',path,dataObject);
                break;
            }
            case 'generateVariationsImage':{
                let path = 'generate/image-to-image-edit';
                let newPromp = variationPrompt(dataObject.positive_prompt);
                dataObject.positive_prompt = newPromp;
                //Add style to prompt: only fpr convert to image and generate variaitons
                const prompt = styleDescriptionPrompt(dataObject.positive_prompt,dataObject.negative_prompt ?? null, inputAiEdit.style,true);
                dataObject.positive_prompt = prompt.positive_prompt;
                dataObject.negative_prompt = prompt.negative_prompt;
                dataObject.model = `${inputAiEdit.selectedAiModel}_Image_Edit`;

                if(marqueeArea){
                    newAiRefference.createNewLayer = true;
                    setInputAiEdit(prev => ({
                        ...prev,
                        reference: newAiRefference
                    }));
                }
                startNewJob('image_gen',path,dataObject);
                break;
            }
            case 'expanding':{
                let path = 'generate/image-outpaint';
                let newPrompts = expandImagePrompt(dataObject.positive_prompt, dataObject.negative_prompt ?? null);
                //Add style to prompt: only fpr convert to image and generate variaitons
                const prompt = styleDescriptionPrompt(newPrompts.positive_prompt,newPrompts.negative_prompt ?? null, inputAiEdit.style,true);
                
                const parsedData: OutPaintGenerationProps = {
                    image : dataObject.image,
                    left: expandPadding?.left ?? 0,
                    right: expandPadding?.right ?? 0,
                    top: expandPadding?.top ?? 0,
                    bottom: expandPadding?.bottom ?? 0,
                    feathering: 24,
                    steps: inputAiEdit.samplingSteps,
                    guidance: inputAiEdit.creativity,
                    positive_prompt: prompt.positive_prompt
                }

                startNewJob('image_gen',path,parsedData);
                onResetExpandState?.();
                break;
            }
            case 'spellCorrection' :{
                setState(null);
                setStateLLM('send');
                setLLMResponseType('spellCorrection');
                setAiGenerationIsRunning(true);
                let text = "textData" in newAiRefference.content && newAiRefference.content.textData ? newAiRefference.content.textData.text : '';
                let newPromp = spellCorrectionPrompt(text,dataObject.positive_prompt, dataObject.negative_prompt);
                const prompt = newPromp;
                const body: AiLLMProps = {
                    model:"gpt-oss:20b",
                    messages: [{role: 'user', content: prompt}]
                };
                let path = 'chat';
                sendMessage(path,body,true);    
                break
            }
            case 'imageUpscale-2x': {
                let path='generate/image-upscale-2x';
                let newObject = {
                    positive_prompt : "",
                    image : dataObject.image
                };
                startNewJob('image_gen',path,newObject);
                break;
            }
            case 'imageUpscale-4x': {
                let path = 'generate/image-upscale-4x';
                let newObject = {
                    positive_prompt : "",
                    image : dataObject.image
                };
                startNewJob('image_gen',path,newObject);
                break;
            }
            case "extractObject": {
                const path = "generate/image-remove-background";

                let referenceForExtraction: AiLayerVariationGenerationProps | null = null;
                
                if (layerAreaSelection) {
                    //1. copy selected area in new layer -> new layer is new selected layer (Copy area selection works on base image and selected layer)
                    const result = await onDuplicateSelectedAreaFromLayer();
                    const copiedLayer = result?.copiedLayer;

                    if (!copiedLayer) {
                        setStateAiEdit("error");
                        setAiGenerationIsRunning(false);
                        return;
                    }

                    referenceForExtraction = {
                        ...buildAiReferenceFromLayer(
                            copiedLayer,
                            "layer",
                            false
                        ),
                        replaceDirectly: true
                    };
                } else {
                    referenceForExtraction = {
                        ...newAiRefference,
                        replaceDirectly: true
                    };
                }

                const file = await getImageFromAiContent(referenceForExtraction.content);

                if (!file) {
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }

                const base64Image = await fileToBase64(file);
                //2. await for new layer --> set new ai input reference for selected layer
                setInputAiEdit(prev => ({
                    ...prev,
                    reference: referenceForExtraction
                }));
                //3. remove background for new layer --> returns extracted object
                const removeBgObject = {
                    positive_prompt: "",
                    image: base64Image
                };

                startNewJob('image_gen', path, removeBgObject, [1]);
                break;
            }
            case 'extractPose': {
                //TODO
                dataObject.number_of_images=1;
                break;
            }
            case 'removeBackground': {
                let path="generate/image-remove-background";
                let newObject = {
                    positive_prompt : "",
                    image : dataObject.image
                };

                //replace layer / base directly and avoid setting variation
                setInputAiEdit(prev => ({
                    ...prev,
                    reference: {
                        ...newAiRefference,
                        replaceDirectly: true
                    }
                }));
                startNewJob('image_gen',path,newObject,[1]);
                break;
            }
            case "removeObject": {
                // 1. Delete area selection (works on base image and layer)
                if (!layerAreaSelection) {
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }

                const result = await onDeleteSelectedAreaFromLayer();

                if (!result) {
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }
                // 2. Await for change: base or selected layer will be new set --> adjust edit ai refernce for correct connections
                let referenceForFill: AiLayerVariationGenerationProps | null = null;

                if (result.sourceType === "base" && result.updatedImage) {
                    referenceForFill = buildAiReferenceFromImage(result.updatedImage, false);
                }

                if (result.sourceType === "layer" && result.updatedLayer) {
                    referenceForFill = buildAiReferenceFromLayer(
                        result.updatedLayer,
                        "layer",
                        false
                    );
                }

                if (!referenceForFill) {
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }

                // 3. Image edit: Fill transparent area

                const prompt = removeObjectPrompt(inputAiEdit.prompt_positive);

                await startImageEditJob(
                    referenceForFill,
                    prompt.positive,
                    prompt.negative,
                    inputAiEdit.numberGenerations
                );

                break;
            }
            case "extractAndRemoveObject": {
                // 1. Extract area selection: New selected layer with copied area --> Remember original target with now deleted area
                if (!layerAreaSelection) {
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }

                const result = await onExtractSelectedAreaToNewLayer();

                if (!result?.copiedLayer) {
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }

                const extractedLayerReference = {
                    ...buildAiReferenceFromLayer(
                        result.copiedLayer,
                        "layer",
                        false
                    ),
                    replaceDirectly: true
                };
                // 2. Await for changes: keep original target and set new ai input reference

                let originalTargetReference: AiLayerVariationGenerationProps | null = null;

                if (result.sourceType === "base" && result.updatedImage) {
                    originalTargetReference = buildAiReferenceFromImage(result.updatedImage, false);
                }

                if (result.sourceType === "layer" && result.updatedLayer) {
                    originalTargetReference = buildAiReferenceFromLayer(
                        result.updatedLayer,
                        "layer",
                        false
                    );
                }

                if (!originalTargetReference) {
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }
                // 3. Originial target: remove object work flow (means: fill transparent area)
                pendingExtractAndRemoveFillRef.current = originalTargetReference;

                const file = await getImageFromAiContent(extractedLayerReference.content);

                if (!file) {
                    pendingExtractAndRemoveFillRef.current = null;
                    setStateAiEdit("error");
                    setAiGenerationIsRunning(false);
                    return;
                }

                const base64Image = await fileToBase64(file);
                // 4. New selected area with copied area -> Remove Background
                setInputAiEdit(prev => ({
                    ...prev,
                    reference: extractedLayerReference
                }));

                startNewJob('image_gen', "generate/image-remove-background", {
                    positive_prompt: "",
                    image: base64Image
                }, [1]);

                break;
            }
        }
    };

    //FUNCTIONS EDIT
    //set time out for applying values
    const EDIT_COMMIT_DELAY = 1_000;

    const filterCommitTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const pendingFilterRef = useRef<ColorFilterProps>(colorFilterList[0]);
    const pendingTransparencyRef = useRef<{ color: string; alpha: number; tolerance: number } | null>({
        color: '#ffffff',
        alpha: 1.0,
        tolerance: 40
    });
    const pendingTransparencyTransitionRef = useRef<{ color: string; alpha: number; tolerance: number } | null>({
        color: '#ffffff',
        alpha: 1.0,
        tolerance: 40
    });
    const clearPendingFilterCommit = () => {
        if (filterCommitTimerRef.current) {
            clearTimeout(filterCommitTimerRef.current);
            filterCommitTimerRef.current = null;
        }
    };
    const drawImageToCanvas = async (src: string, targetCanvas: HTMLCanvasElement) => {
        const htmlImg = await loadImage(src);
        const ctx = targetCanvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) return;

        targetCanvas.width = htmlImg.naturalWidth;
        targetCanvas.height = htmlImg.naturalHeight;
        ctx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
        ctx.drawImage(htmlImg, 0, 0);
    };
    const getCurrentBaseTitle = (patch?: Partial<SettingsPanelEditInputProps>) => {
        return (
            patch?.title ||
            inputEdit.title ||
            image?.title ||
            image?.file?.name ||
            "image"
        );
    };

    const emitCurrentCanvas = async (
        patch?: Partial<SettingsPanelEditInputProps>
    ) => {
        if (!canvasRef.current) return;

        const title = stripKnownImageStudioExtensions(getCurrentBaseTitle(patch));
        const file = await canvasToFile(canvasRef.current, `${title}.png`);
        // eslint-disable-next-line no-restricted-syntax -- internes State-Update (kein Download), Art. 50 KI-VO nicht einschlaegig
        const dataUrl = canvasRef.current.toDataURL("image/png");
        const dims = await getImageDimensions(file);

        const nextEdit: SettingsPanelEditInputProps = {
            ...inputEditRef.current,
            ...patch,
            title,
            imgSrc: dataUrl,
            baseImgSrc: patch?.baseImgSrc ?? inputEdit.baseImgSrc,
            imgFile: file,
            width: dims.width,
            height: dims.height
        };

        lastLocallyEditedSrcRef.current = dataUrl;
        setInputEdit(nextEdit);
        setHistoryEdit(prev => [...prev, nextEdit]);
    };
    const previewFromBase = async (
        baseSrc: string,
        filters: ColorFilterProps,
        transparency: { color: string; alpha: number; tolerance:number } | null,
        transparencyTransition: { color: string; alpha: number; tolerance:number } | null,
    ) => {
        if (!canvasRef.current || !baseSrc) return;
        const token = ++previewTokenRef.current;

        const htmlImg = await loadImage(baseSrc);
        if (token !== previewTokenRef.current) return;
        applyColorFilters(htmlImg, canvasRef.current, filters);
        applySelectedColorTransparency(canvasRef.current, transparency);
        applySelectedColorTransparencyTransition(canvasRef.current, transparencyTransition);
    };
    const renderPreviewFromBase = async (
        baseSrc: string,
        filters: ColorFilterProps,
        transparency: { color: string; alpha: number; tolerance:number } | null,
        transparencyTransition: { color: string; alpha: number; tolerance:number } | null,
        patch?: Partial<SettingsPanelEditInputProps>
    ) => {
        if (!canvasRef.current || !baseSrc) return;

        const htmlImg = await loadImage(baseSrc);
        applyColorFilters(htmlImg, canvasRef.current, filters);
        applySelectedColorTransparency(canvasRef.current, transparency);
        applySelectedColorTransparencyTransition(canvasRef.current, transparencyTransition)

        await emitCurrentCanvas({
            ...patch,
            baseImgSrc: baseSrc,
            colorFilterData: filters,
            transparency,
            transparencyTransition
        });
    };
    const commitGeometryCanvas = async (
        workCanvas: HTMLCanvasElement,
        patch?: Partial<SettingsPanelEditInputProps>
    ) => {
        // eslint-disable-next-line no-restricted-syntax -- internes State-Update (kein Download), Art. 50 KI-VO nicht einschlaegig
        const baseDataUrl = workCanvas.toDataURL("image/png");

        await renderPreviewFromBase(
            baseDataUrl,
            pendingFilterRef.current,
            pendingTransparencyRef.current,
            pendingTransparencyTransitionRef.current,
            {
                ...patch,
                baseImgSrc: baseDataUrl
            }
        );
    };
    const runGeometryEdit = async (
        editor: (canvas: HTMLCanvasElement) => void,
        patch?: Partial<SettingsPanelEditInputProps>
    ) => {
        clearPendingFilterCommit();

        const currentEdit = inputEditRef.current;
        const source =currentEdit.baseImgSrc || currentEdit.imgSrc || currentEdit.originalImgSrc;
        if (!source) return;

        const workCanvas = document.createElement("canvas");
        await drawImageToCanvas(source, workCanvas);

        editor(workCanvas);

        await commitGeometryCanvas(workCanvas, {
            ...patch,
            title: getCurrentBaseTitle(patch)
        });
    };
    const scheduleFilterCommit = (
        nextFilters: ColorFilterProps,
        nextTransparency: { color: string; alpha: number, tolerance: number } | null,
        nextTransparencyTransition: { color: string; alpha: number, tolerance: number } | null
    ) => {
        pendingFilterRef.current = nextFilters;
        pendingTransparencyRef.current = nextTransparency;
        pendingTransparencyTransitionRef.current = nextTransparencyTransition;

        clearPendingFilterCommit();

        filterCommitTimerRef.current = setTimeout(async () => {
            await renderPreviewFromBase(
                inputEditRef.current.baseImgSrc || inputEditRef.current.originalImgSrc,
                pendingFilterRef.current,
                pendingTransparencyRef.current,
                pendingTransparencyTransitionRef.current,
                {
                    colorFilterData: pendingFilterRef.current,
                    transparency: pendingTransparencyRef.current,
                    transparencyTransition: pendingTransparencyTransitionRef.current
                }
            );
        }, EDIT_COMMIT_DELAY);
    };
    const addColorFilterSettingsToInput = async (item: ColorFilterProps) => {
        pendingFilterRef.current = item;
        setColorFilter(item);

        setInputEdit(prev => ({
            ...prev,
            colorFilterName: item.name,
            colorFilterData: item
        }));

        void previewFromBase(
            inputEdit.baseImgSrc || inputEditRef.current.originalImgSrc,
            item,
            pendingTransparencyRef.current,
            pendingTransparencyTransitionRef.current
        );

        scheduleFilterCommit(item, pendingTransparencyRef.current, pendingTransparencyTransitionRef.current);
    };
    const applySpecificEditValue = async (name: string, val: number) => {
        const nextFilters = {
            ...pendingFilterRef.current,
            [name]: val
        } as ColorFilterProps;

        pendingFilterRef.current = nextFilters;
        setColorFilter(nextFilters);

        setInputEdit(prev => ({
            ...prev,
            colorFilterData: nextFilters
        }));

        void previewFromBase(
            inputEditRef.current.baseImgSrc || inputEditRef.current.originalImgSrc,
            nextFilters,
            pendingTransparencyRef.current,
            pendingTransparencyTransitionRef.current
        );

        scheduleFilterCommit(nextFilters, pendingTransparencyRef.current, pendingTransparencyTransitionRef.current);
    };

    //BASE IMAGE EDIT FUNCTIONS
    const stopRotate = () => {
        onIsRotating?.(false);
    };

    const flipHorizontal = async () => {
        const currentEdit = inputEditRef.current;
        const nextValue = !currentEdit.flipHorizontal;

        await runGeometryEdit(
            (workCanvas) => flipCanvas(workCanvas, true, false),
            { flipHorizontal: nextValue }
        );
    };

    const flipVertical = async () => {
        const currentEdit = inputEditRef.current;
        const nextValue = !currentEdit.flipVertical;

        await runGeometryEdit(
            (workCanvas) => flipCanvas(workCanvas, false, true),
            { flipVertical: nextValue }
        );
    };
    const rectToVisibleCanvasCrop = (r: OverlayRect) => {
        const canvas = canvasRef?.current;
        const visibleBounds = getVisibleCanvasBoundsInWrapper();

        if (!canvas || !visibleBounds) return null;

        const {
            left: visibleLeftInWrapper,
            top: visibleTopInWrapper,
            width: visibleWidthInWrapper,
            height: visibleHeightInWrapper,
            fullCanvasLeftInWrapper,
            fullCanvasTopInWrapper,
            fullCanvasDisplayWidth,
            fullCanvasDisplayHeight
        } = visibleBounds;

        // OverlayRect ist jetzt relativ zum SICHTBAREN Bereich
        const cropLeftInWrapper = visibleLeftInWrapper + r.x * visibleWidthInWrapper;
        const cropTopInWrapper = visibleTopInWrapper + r.y * visibleHeightInWrapper;
        const cropWidthInWrapper = r.w * visibleWidthInWrapper;
        const cropHeightInWrapper = r.h * visibleHeightInWrapper;

        // zurück auf komplettes Canvas-Display
        const cropLeftInCanvasDisplay = cropLeftInWrapper - fullCanvasLeftInWrapper;
        const cropTopInCanvasDisplay = cropTopInWrapper - fullCanvasTopInWrapper;

        // Display -> echte Canvas-Pixel
        const scaleX = canvas.width / fullCanvasDisplayWidth;
        const scaleY = canvas.height / fullCanvasDisplayHeight;

        const x = Math.round(cropLeftInCanvasDisplay * scaleX);
        const y = Math.round(cropTopInCanvasDisplay * scaleY);
        const w = Math.round(cropWidthInWrapper * scaleX);
        const h = Math.round(cropHeightInWrapper * scaleY);

        return {
            x: Math.max(0, Math.min(canvas.width - 1, x)),
            y: Math.max(0, Math.min(canvas.height - 1, y)),
            w: Math.max(1, Math.min(canvas.width - x, w)),
            h: Math.max(1, Math.min(canvas.height - y, h)),
        };
    };
    const handleTransparencyColorChange = async (value: string) => {
        const nextTransparency = {
            color: value,
            alpha: pendingTransparencyRef.current?.alpha ?? 1.0,
            tolerance: pendingTransparencyRef.current?.tolerance ?? 40
        };

        pendingTransparencyRef.current = nextTransparency;

        setInputEdit(prev => ({
            ...prev,
            transparency: nextTransparency
        }));

        void previewFromBase(
            inputEdit.baseImgSrc || inputEditRef.current.originalImgSrc,
            pendingFilterRef.current,
            nextTransparency,
            pendingTransparencyTransitionRef.current
        );

        scheduleFilterCommit(pendingFilterRef.current, nextTransparency, pendingTransparencyTransitionRef.current);
    };
    const handleTransparencyAlphaChange = async (value: number) => {
        const nextTransparency = {
            color: pendingTransparencyRef.current?.color ?? '#ffffff',
            alpha: Math.max(0, Math.min(1, value)),
            tolerance: pendingTransparencyRef.current?.tolerance ?? 40
        };

        pendingTransparencyRef.current = nextTransparency;

        setInputEdit(prev => ({
            ...prev,
            transparency: nextTransparency
        }));

        void previewFromBase(
            inputEdit.baseImgSrc || inputEditRef.current.originalImgSrc,
            pendingFilterRef.current,
            nextTransparency,
            pendingTransparencyTransitionRef.current
        );

        scheduleFilterCommit(pendingFilterRef.current, nextTransparency, pendingTransparencyTransitionRef.current);
    };
    const handleTransparencyToleranceChange = async (value: number) => {
        const nextTransparency = {
            color: pendingTransparencyRef.current?.color ?? '#ffffff',
            alpha: pendingTransparencyRef.current?.alpha ?? 1.0,
            tolerance: value
        };

        pendingTransparencyRef.current = nextTransparency;

        setInputEdit(prev => ({
            ...prev,
            transparency: nextTransparency
        }));

        void previewFromBase(
            inputEdit.baseImgSrc || inputEdit.originalImgSrc,
            pendingFilterRef.current,
            nextTransparency,
            pendingTransparencyTransitionRef.current
        );

        scheduleFilterCommit(pendingFilterRef.current, nextTransparency, pendingTransparencyTransitionRef.current);
    };
    const handleTransparencyTransitionColorChange = async (value: string) => {
        const nextTransparency = {
            color: value,
            alpha: pendingTransparencyTransitionRef.current?.alpha ?? 1.0,
            tolerance: pendingTransparencyTransitionRef.current?.tolerance ?? 40
        };

        pendingTransparencyTransitionRef.current = nextTransparency;

        setInputEdit(prev => ({
            ...prev,
            transparencyTransition: nextTransparency
        }));

        void previewFromBase(
            inputEdit.baseImgSrc ||inputEditRef.current.originalImgSrc,
            pendingFilterRef.current,
            pendingTransparencyRef.current,
            nextTransparency
        );

        scheduleFilterCommit(pendingFilterRef.current, pendingTransparencyRef.current ,nextTransparency);
    };
    const handleTransparencyTransitionAlphaChange = async (value: number) => {
        const nextTransparency = {
            color: pendingTransparencyTransitionRef.current?.color ?? '#ffffff',
            alpha: Math.max(0, Math.min(1, value)),
            tolerance: pendingTransparencyTransitionRef.current?.tolerance ?? 40
        };

        pendingTransparencyTransitionRef.current = nextTransparency;

        setInputEdit(prev => ({
            ...prev,
            transparencyTransition: nextTransparency
        }));

        void previewFromBase(
            inputEdit.baseImgSrc || inputEditRef.current.originalImgSrc,
            pendingFilterRef.current,
            pendingTransparencyRef.current,
            nextTransparency
        );

        scheduleFilterCommit(pendingFilterRef.current, pendingTransparencyRef.current ,nextTransparency);
    };
    const handleTransparencyTransitionToleranceChange = async (value: number) => {
        const nextTransparency = {
            color: pendingTransparencyTransitionRef.current?.color ?? '#ffffff',
            alpha: pendingTransparencyTransitionRef.current?.alpha ?? 1.0,
            tolerance: value
        };

        pendingTransparencyTransitionRef.current = nextTransparency;

        setInputEdit(prev => ({
            ...prev,
            transparencyTransition: nextTransparency
        }));

        void previewFromBase(
            inputEdit.baseImgSrc || inputEditRef.current.originalImgSrc,
            pendingFilterRef.current,
            pendingTransparencyRef.current,
            nextTransparency
        );

        scheduleFilterCommit(pendingFilterRef.current, pendingTransparencyRef.current ,nextTransparency);
    };

    // Keep edit source in sync with selected image
    useEffect(() => {
        const src = image?.src ?? '';
        if (!src) return;

        // reset states only if new image was loaded
        if (src === lastLocallyEditedSrcRef.current) {
            setInputEdit(prev => ({
                ...prev,
                imgSrc: src,
                imgFile: image?.file ?? prev.imgFile,
                width: image?.width ?? prev.width,
                height: image?.height ?? prev.height,
                title: image?.title ?? prev.title
            }));
            return;
        }
        clearPendingFilterCommit();

        pendingFilterRef.current = colorFilterList[0];
        pendingTransparencyRef.current = {
            color: '#ffffff',
            alpha: 1.0,
            tolerance: 40
        };
        pendingTransparencyTransitionRef.current = {
            color: '#ffffff',
            alpha: 1.0,
            tolerance: 40
        };

        setColorFilter(colorFilterList[0]);
        onChangeRotationDraft?.(0);

        setInputEdit(prev => {
            const nextWidth = image?.width ?? prev.width;
            const nextHeight = image?.height ?? prev.height;
            const nextTitle =
                image?.title ||
                image?.file?.name ||
                prev.title ||
                "image";

            return {
                ...prev,
                originalImgSrc: src,
                baseImgSrc: src,
                imgSrc: src,
                imgFile: image?.file ?? null,
                width: nextWidth,
                height: nextHeight,
                title: nextTitle,
                colorFilterName: 'No Filter',
                colorFilterData: colorFilterList[0],
                transparency: {
                    color: '#ffffff',
                    alpha: 1,
                    tolerance: 40
                },
                transparencyTransition: {
                    color: '#ffffff',
                    alpha: 1,
                    tolerance: 40
                },
                cropRect: null,
                rotation: 0,
                flipHorizontal: false,
                flipVertical: false,
            };
        });

        (async () => {
            try {
                if (!canvasRef?.current) return;
                await drawImageToCanvas(src, canvasRef.current);
            } catch {
                // ignore
            }
        })();
    }, [image?.src]);
    // Hide context menu on outside click / escape
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                if (isPickingTransparencyColor) {
                    onToggleTransparencyColorPicker?.();
                }
            }
        };

        window.addEventListener('keydown', onKey);

        return () => {
            window.removeEventListener('keydown', onKey);
        };
    }, []);
    useEffect(() => {
        return () => {
            clearPendingFilterCommit();
        };
    }, []);
    
    useEffect(()=>{
        handleGenerationResult();
    },[generation]);
    useEffect(()=>{
        handleVariationGenerationResultEdit();
    },[generationAiEdit]);

    // Live rotation preview via CSS transform while rotate overlay is active
    useEffect(() => {
        const el = wrapperRef.current;
        if (!el) return;

        const stage = el.querySelector('.image-stage') as HTMLDivElement | null;
        if (stage) {
            stage.style.transformOrigin = 'center center';
            stage.style.transform = `rotate(${rotationDraft}deg)`;
        }

        return () => {
            if (stage) {
                stage.style.transform = 'none';
                stage.style.transformOrigin = '';
            }
        };
    }, [rotateMode, rotationDraft, wrapperRef]);

    // mouse move / up for rotation drag
    useEffect(() => {
        onRotatePreviewChange?.(rotateMode)
        const onMove = (e: MouseEvent) => handleRotateMove?.(e);
        const onUp = () => stopRotate();
        if (rotateMode) {
            window.addEventListener('mousemove', onMove);
            window.addEventListener('mouseup', onUp);
        }
        return () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
        };
    }, [rotateMode, isRotating]);

    useEffect(() => {
        if (!rotateMode) {
            setRotationInputValue(0);
        }
        else{
            setRotationInputValue(rotationDraft);
        }
    }, [inputEdit.rotation, rotateMode]);

    useEffect(()=> {
        if(!inputEdit.originalImgSrc || !inputEdit.imgSrc){
            onToggleCropeMode?.(false);
            onToggleRotationMode?.(false);
        }
    },[inputEdit.originalImgSrc,inputEdit.imgSrc]);

    useEffect(()=> {
        if(historyEdit.length > 0){
            //get last change
            let lastImage = historyEdit.at(-1);
            if(lastImage && onImageEdited){
                onImageEdited(lastImage);
            }
        }
    },[historyEdit]);

    useEffect(() => {
        if (!pickedTransparencyTransitionColor) return;

        handleTransparencyTransitionColorChange(pickedTransparencyTransitionColor);
        onTransparencyTransitionColorPicked?.("");
    }, [pickedTransparencyTransitionColor]);

    useEffect(() => {
        if (!pickedTransparencyColor) return;

        handleTransparencyColorChange(pickedTransparencyColor);
        onTransparencyColorPicked?.("");
    }, [pickedTransparencyColor]);
    
    useEffect(() => {
        centerCanvas?.();
    }, [inputEdit.width, inputEdit.height]);
    //disable new generations while still running
    useEffect(()=>{
        if(aiGenerationIsRunning){
            setAiFunctionsAreDisabled(true);
        }
        else{
            setAiFunctionsAreDisabled(false);
        }
    },[aiGenerationIsRunning]);
    useEffect(()=>{
        if(stateAiEdit === 'send' || stateAiEdit === "waiting" || state === 'send' || state === 'waiting' || stateLLM === 'send' || stateLLM === 'waiting'){
            setAiGenerationIsRunning(true);
        }
        else{
            setAiGenerationIsRunning(false);
        }
        if(stateLLM && llmResponseType === 'spellCorrection'){
            setStateAiEdit(stateLLM);
        }
        setAiGenerationsState(stateAiEdit ?? state ?? stateLLM);

        if(stateAiEdit === 'done'){
            setTimeout(() => {
                setStateAiEdit(null);
            }, stateTimeoutTime);
        }

        if(stateLLM === 'done'){
            setTimeout(()=>{
                setStateLLM(null);
            },stateTimeoutTime);
        }

        if(state === 'done'){
            setTimeout(()=> {
                setState(null);
            }, stateTimeoutTime);
        }
    },[stateAiEdit, state, stateLLM]);
    useEffect(() => {
        setAiGenerationIsRunning(false);

        if (!generationLLM || !llmResponseType) return;

        switch (llmResponseType) {
            case "create": {
                const promptResponse = parsePromptResponse(generationLLM);
                if (!promptResponse) return;

                setLLMResponseType(null);

                setInputCreate(prev => ({
                    ...prev,
                    prompt_positive: promptResponse.positive_prompt,
                    prompt_negative: promptResponse.negative_prompt ?? ""
                }));

                break;
            }

            case "edit": {
                const promptResponse = parsePromptResponse(generationLLM);
                if (!promptResponse) return;

                setLLMResponseType(null);

                setInputAiEdit(prev => ({
                    ...prev,
                    prompt_positive: promptResponse.positive_prompt,
                    prompt_negative: promptResponse.negative_prompt ?? ""
                }));

                break;
            }

            case "spellCorrection": {
                setLLMResponseType(null);

                const refContent = inputAiEdit.reference?.content;

                if (refContent && isLayerProps(refContent) && refContent.textData && typeof generationLLM === "string") {
                    const currentLayer: LayerProps = {
                        ...refContent,
                        textData: {
                            ...refContent.textData,
                            text: generationLLM
                        },
                        type: 'text',
                        imageData: undefined,
                        imageEdit: undefined
                    };

                    onChangeLayer?.(
                        allLayer.map(item =>
                            item.layerID !== currentLayer.layerID
                                ? item
                                : currentLayer
                        )
                    );
                }

                setInputAiEdit(prev => ({
                    ...prev,
                    reference: null
                }));

                setAiGenerationIsRunning(false);
                break;
            }
        }
    }, [generationLLM]);
    useEffect(() => {
        onAiEditInputChange?.(inputAiEdit);
    }, [inputAiEdit, onAiEditInputChange]);
    useEffect(() => {
        let cancelled = false;

        const buildMarkedPreview = async () => {
            if (!layerAreaSelection || !aiEditReference) {
                setMarkedReferencePreview(null);
                return;
            }

            let sourceCanvas: HTMLCanvasElement | null = null;
            let offsetX = 0;
            let offsetY = 0;

            if (layerAreaSelection.layerId === -1) {
                if (!image?.src) {
                    setMarkedReferencePreview(null);
                    return;
                }

                const img = await loadImage(image.src);

                sourceCanvas = document.createElement("canvas");
                sourceCanvas.width = image.width || img.naturalWidth || img.width;
                sourceCanvas.height = image.height || img.naturalHeight || img.height;

                const ctx = sourceCanvas.getContext("2d");
                if (!ctx) return;

                ctx.drawImage(img, 0, 0, sourceCanvas.width, sourceCanvas.height);
            } else {
                const sourceLayer = allLayer.find(layer => layer.layerID === layerAreaSelection.layerId);
                if (!sourceLayer) {
                    setMarkedReferencePreview(null);
                    return;
                }

                sourceCanvas = document.createElement("canvas");
                sourceCanvas.width = Math.max(1, Math.round(sourceLayer.width));
                sourceCanvas.height = Math.max(1, Math.round(sourceLayer.height));

                offsetX = sourceLayer.position.x;
                offsetY = sourceLayer.position.y;

                const ctx = sourceCanvas.getContext("2d");
                if (!ctx) return;

                await renderLayerToCanvas(ctx, {
                    ...sourceLayer,
                    position: { x: 0, y: 0 },
                    rotation: 0
                });
            }

            const previewCanvas = document.createElement("canvas");
            previewCanvas.width = sourceCanvas.width;
            previewCanvas.height = sourceCanvas.height;

            const ctx = previewCanvas.getContext("2d");
            if (!ctx) return;

            ctx.drawImage(sourceCanvas, 0, 0);

            ctx.save();
            ctx.fillStyle = "rgba(0,0,0,0.55)";
            ctx.fillRect(0, 0, previewCanvas.width, previewCanvas.height);
            ctx.restore();

            ctx.save();
            drawSelectionPath(ctx, layerAreaSelection, offsetX, offsetY);
            ctx.clip();
            ctx.drawImage(sourceCanvas, 0, 0);
            ctx.restore();

            ctx.save();
            drawSelectionPath(ctx, layerAreaSelection, offsetX, offsetY);
            ctx.strokeStyle = SengiColors.sng_lavendel;
            ctx.lineWidth = Math.max(2, Math.round(Math.min(previewCanvas.width, previewCanvas.height) * 0.01));
            ctx.setLineDash([10, 6]);
            ctx.stroke();
            ctx.restore();

            // eslint-disable-next-line no-restricted-syntax -- interne Vorschau-Generierung (kein Download), Art. 50 KI-VO nicht einschlaegig
            const src = previewCanvas.toDataURL("image/png");

            if (!cancelled) {
                setMarkedReferencePreview([{
                    file: null,
                    src,
                    width: previewCanvas.width,
                    height: previewCanvas.height,
                    timeOfUse: new Date(),
                    title: t('label.markedArea')
                }]);
            }
        };

        void buildMarkedPreview();

        return () => {
            cancelled = true;
        };
    }, [
        layerAreaSelection,
        aiEditReference,
        image?.src,
        image?.width,
        image?.height,
        allLayer
    ]);
    useEffect(()=>{
        //update cost
        updateImageCreationCosts();
    },[inputCreate]);
    useEffect(()=>{
        //update costs
        updateImageEditCosts();
    },[inputAiEdit]);
    useEffect(() => {
        inputEditRef.current = inputEdit;
    }, [inputEdit]);

    
    const settingsSideBar = (<>
        {insufficientCreditsDialogCreate}
        {insufficientCreditsDialogEdit}
        {insufficientCreditsDialogLLM}
        {  switchImageCreateEdit
            ?   <div className="row m-2 p-0">
                    <div className="col-6 p-0 pe-1">
                        <EffectThemeButton
                            className="btn border-secondary rounded w-100"
                            title={t('tab.createImage')}
                            active={creatingActive}
                            onClick={() => setCreatingActiv(true)}
                            children={<>
                            <FontAwesomeIcon
                                icon={faWandMagicSparkles}
                                className="me-2"
                            />
                            {createImageButtonText}
                            </>}
                        />
                    </div>
                    <div className="col-6 p-0 ps-1">
                        <EffectThemeButton
                            className="btn border-secondary rounded w-100"
                            title={t('tab.editImage')}
                            active={!creatingActive}
                            onClick={() => setCreatingActiv(false)}
                            children={<>
                            <FontAwesomeIcon
                                icon={faPenFancy}
                                className="me-2"
                            />
                            {editImageButtonText}
                            </>}
                        />
                    </div>
                </div>
            :   <></>
        }
            {
                (creatingActive && switchImageCreateEdit) || (!switchImageCreateEdit)
                ?   <>
                        
                        <EffectThemeContainer
                            containerClass="m-2 p-2 mt-0"
                            children={<div className="col m-0 p-0">
                                <div className="row mb-2">
                                    <div className="col">
                                        <button
                                            className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                            onClick={() => setShowPrompt(!showPrompt)}
                                        >
                                            <FontAwesomeIcon
                                                icon={showPrompt ? faChevronDown : faChevronRight}
                                                className="me-2"
                                            />
                                            Prompt
                                        </button>
                                    </div>
                                    {
                                        showPrompt
                                        ?   <div className='col-auto'>
                                                <InfoPopoverButton
                                                    width={520}
                                                    maxHeight={650}
                                                    children={<WorkLoadPromptInfoElement/>}
                                                    image={sengiInfo2}   
                                                    imageHeight={40}
                                                    imageWidth={60}
                                                    imageBorder={false}
                                                />
                                            </div>
                                        : <></>
                                    }
                                </div>
                                
                            {
                                    showPrompt
                                    ? <>                                   
                                <div className="row p-0 m-0 mt-2 align-items-center">
                                    <div className="col">
                                        <label htmlFor="prompt_positive" className="form-label ps-0">{positiveAndNegativePrompt ? t('prompt.positive') : t('prompt.promptOnly') }</label>
                                    </div>
                                    {
                                        generateRandomPrompt 
                                        ?   <div className="col-auto p-0">
                                                <button
                                                    title={generateRandomPromptText}
                                                    className="btn border-0 bg-transparent w-100"
                                                    disabled={aiFunctionsAreDisabled}
                                                    onClick={()=>handleRandomPrompt('create')}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faDice}
                                                    />
                                                    <span
                                                        style={{
                                                            position: "relative",
                                                            top: "-5px",
                                                            right: "-5px",
                                                            transform: "scale(0.5)",
                                                            pointerEvents: "none"
                                                        }}
                                                    >
                                                        <FreeLogo size={12}/>
                                                    </span>
                                                </button>
                                            </div>
                                        :   <></>
                                    }
                                    {
                                        checkPrompt 
                                        ?   <div className="col-auto p-0">
                                                <button
                                                    title={checkPromptText}
                                                    className="btn border-0 bg-transparent w-100"
                                                    onClick={()=> handleCheckPrompt('create')}
                                                    disabled={aiFunctionsAreDisabled}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faCheckDouble}
                                                    />
                                                    <span
                                                        style={{
                                                            position: "relative",
                                                            top: "-5px",
                                                            right: "-5px",
                                                            transform: "scale(0.5)",
                                                            pointerEvents: "none"
                                                        }}
                                                    >
                                                        <FreeLogo size={12}/>
                                                    </span>
                                                </button>
                                            </div>
                                        :   <></>
                                    }
                                </div>
                                <div className='row p-0 m-0'>
                                    <textarea
                                        className="form-control"
                                        id="prompt_positive"
                                        name='prompt_positive'
                                        rows={3}
                                        value={inputCreate.prompt_positive}
                                        onChange={(e) => handleTextareaChangeCreate(e)}
                                        placeholder={t('prompt.placeholderPositive')}
                                    />
                                </div>
                                {
                                    positiveAndNegativePrompt
                                    ?   <div className='row p-0 m-0 mt-2'>
                                            <label htmlFor="prompt_negative" className="form-label ps-0">{t('prompt.negative')}</label>
                                            <EffectThemeTextarea
                                                className="form-control"
                                                id="prompt_negative"
                                                name="prompt_negative"
                                                rows={3}
                                                value={inputCreate.prompt_negative}
                                                onChange={(e) => handleTextareaChangeCreate(e)}
                                                placeholder={t('prompt.placeholderNegative')}
                                            /> 
                                        </div>
                                    : <></>
                                }     
                                <div className="row p-0 m-0 mt-2">
                                    <div className="col p-0">
                                        <Form.Check
                                            label={'Pos./Neg. Prompt'}
                                            type="switch"
                                            id="single-prompt-switch"
                                            checked={positiveAndNegativePrompt}
                                            onChange={() => setPositiveAndNegativePrompt(prev => !prev)}
                                        />
                                    </div>
                                    <div className="col-auto mb-1 p-0">
                                        <InfoPopoverButton
                                            width={320}
                                            placement="right"
                                        >
                                            <PositiveNegativePromptInfoElement/>
                                        </InfoPopoverButton>
                                    </div>
                                </div>   
                                {
                                    addReferences
                                    ?   inputCreate.reference
                                        ?   <>  <div className="row p-0 m-0 mt-2 align-items-start text-secondary">
                                                    Reference
                                                </div>
                                                <div className="row p-0 m-0 mt-2 align-items-start">
                                                    <div className="col-auto">
                                                        <EffectThemeImageGrid size={'130px'} images={[inputCreate.reference]} />
                                                    </div>

                                                    <div className="col-auto d-flex flex-column gap-2">
                                                        {/* Remove */}
                                                        <button
                                                        type="button"
                                                        onClick={() =>
                                                            setInputCreate(prev => ({
                                                            ...prev,
                                                            reference: null,
                                                            }))
                                                        }
                                                        className="btn p-0 bg-transparent"
                                                        title={t('title.removeReference')}
                                                        >
                                                        <FontAwesomeIcon icon={faTrash} className="me-2" />
                                                        </button>

                                                        {/* Change */}
                                                        <FileUpload
                                                        accept="image/*"
                                                        multiple={false}
                                                        buttonText=""
                                                        titleText={t('title.changeReference')}
                                                        uploadIcon={faArrowRightArrowLeft}
                                                        dragAndDrop={false}
                                                        onFilesSelected={async(files) => {
                                                            const file = files[0];
                                                            if (!file) return;
                                                            const imageDimension = await getImageDimensions(file);
                                                            setInputCreate(prev => ({
                                                                ...prev,
                                                                reference: { src: URL.createObjectURL(file),file:file , width: imageDimension.width, height: imageDimension.height, timeOfUse: new Date()},
                                                            }));
                                                        }}
                                                        />
                                                    </div>
                                                </div>
                                            </>

                                        :   <div className="row p-0 m-0 mt-2">
                                                <FileUpload
                                                    accept="image/*"
                                                    multiple={false}
                                                    buttonText={addReferenceText}
                                                    dragAndDrop={true}
                                                    onFilesSelected={async(files) => {
                                                        let imageDimension = await getImageDimensions(files[0]);
                                                        setInputCreate(prev => ({
                                                        ...prev,
                                                        reference: {'src': URL.createObjectURL(files[0]),file:files[0], width: imageDimension.width, height: imageDimension.height, timeOfUse: new Date()},
                                                        }));
                                                    }}
                                                />
                                            </div>
                                    :   <></>
                                }
                                { stylesList && stylesList.length > 0
                                ?   <>
                                        <div className="my-1">{t('label.style')}</div>
                                        <EffectThemeDropdown.SearchFilter
                                            id="dropdown-style-model"
                                            className="w-100 mb-2"
                                            selectedLabel={stylesList.filter(x => x.item === inputCreate.style).length > 0 ? stylesList.filter(x => x.item === inputCreate.style)[0].name : ''}
                                            items={stylesList}
                                            selectedItem={stylesList.find(x => x.item === inputCreate.style) ?? null}
                                            onSelect={(x) => handleDropdownChangeCreate("style", x.item)}
                                            getItemKey={(x) => x.item}
                                            getItemSearchText={(x) =>`${x.name ?? ""} ${x.item} ${(x.category ?? []).join(" ")}`}
                                            renderItem={renderStyleDropdownItem}
                                            filterGroups={styleFilterGroups}
                                            searchPlaceholder={t('label.searchStyle')}
                                            resetKey={image?.src ?? "create-without-image"}
                                            maxHeight={420}
                                            style={{maxWidth: 400}}
                                        />
                                    </>
                                :   <></>
                            }
                            { aspectRatioList && aspectRatioList.length > 0
                                ?   <>
                                        <div className="row m-0 p-0">
                                            <div className="col-auto mb-1 ps-0">{t('label.aspectRatio')}</div>
                                            <div className="col"></div>
                                            <div className="col-auto mb-1 p-0">
                                                <InfoPopoverButton
                                                    width={320}
                                                    placement="right"
                                                >
                                                    <AspectRatioInfoElement/>
                                                </InfoPopoverButton>
                                            </div>
                                        </div>
                                        <EffectThemeDropdown
                                            className="w-100 mb-2"
                                        >
                                            <EffectThemeDropdown.Toggle
                                                id="dropdown-ai-model"
                                                className="w-100"
                                            >
                                                {inputCreate.aspectRatio}
                                            </EffectThemeDropdown.Toggle>

                                            <EffectThemeDropdown.Menu className="p-1 w-100" maxHeight={420} style={{maxWidth: 400}}>
                                                {aspectRatioList.map((item, index) => (
                                                <EffectThemeDropdown.Item
                                                    key={index}
                                                    onClick={()=> handleDropdownChangeCreate('aspectRatio', item)}
                                                    active={item === inputCreate.aspectRatio}
                                                >
                                                    {item}
                                                </EffectThemeDropdown.Item>
                                                ))}
                                            </EffectThemeDropdown.Menu>
                                        </EffectThemeDropdown>
                                    </>
                                :   <></>
                            }
                            
                            {
                                numberGenerationsMax 
                                ?   <>
                                        <div className="row m-0 p-0">
                                            <div className="col-auto mb-1 ps-0"> {numberOfGenerationsText}: </div>
                                            <div className="col">{inputCreate.numberGenerations}</div>
                                            <div className="col-auto mb-1 p-0">
                                                <InfoPopoverButton
                                                    width={320}
                                                    placement="right"
                                                >
                                                    <NumberOfImagesInfoElement/>
                                                </InfoPopoverButton>
                                            </div>
                                        </div>
                                        <EffectThemeRange
                                            min={1}
                                            max={numberGenerationsMax}
                                            step={1}
                                            name="numberGenerations"
                                            value={inputCreate.numberGenerations}
                                            onChange={val => handleRangeChangeCreate('numberGenerations', val)}
                                            minDescription="1"
                                            maxDescription={String(numberGenerationsMax)}
                                            className="mb-2"
                                                                                    />

                                    </>
                                :   <></>
                            }
                                <div className="row p-0 m-0 mt-2">
                                    <div className="col p-0 w-100">
                                        <EffectThemeButton
                                            className="btn btn-outline-secondary rounded py-1"
                                            title={t('title.createImage')}
                                            disabled={aiFunctionsAreDisabled}
                                            onClick={generateImage}
                                            children ={ 
                                                <>
                                                    <FontAwesomeIcon
                                                        icon={faWandMagicSparkles}
                                                        className="me-2"
                                                    />
                                                    {t('button.generateImage')} <AILogo/>
                                                    <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageCreationCost?.costs ?? 0}</p>
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                                
                                </>
                                : <></>
                            }
                            </div>}
                        />
                        {
                            switchSettingsAndHistory
                            ?   <div className="row m-2 mb-0 p-0" style={{ position: 'relative', zIndex: 1 }}>
                                    <div className="col-6 p-0">
                                        <EffectThemeButton
                                            className="btn border-secondary rounded w-100 border-bottom-0 rounded-top-only"
                                            title={t('title.settings')}
                                            active={settingsActive}
                                            onClick={() => setSettingsActive(true)}
                                            tabPosition="left"
                                            children={<>
                                            <FontAwesomeIcon
                                                icon={faGears}
                                                className="me-2"
                                            />
                                            Settings
                                            </>}
                                        />
                                    </div>
                                    <div className="col-6 p-0">
                                        <EffectThemeButton
                                            className="btn border-secondary rounded w-100 border-bottom-0 rounded-top-only"
                                            title={t('title.history')}
                                            active={!settingsActive}
                                            onClick={() => setSettingsActive(false)}
                                            tabPosition="left"
                                            children={<>
                                            <FontAwesomeIcon
                                                icon={faClockRotateLeft}
                                                className="me-2"
                                            />
                                            History
                                            </>}
                                        />
                                    </div>
                                </div>
                            :   <></>
                        }
                        {
                            settingsActive
                            ?   <div style={{ position: 'relative', zIndex: 10 }}>
                                    <EffectThemeContainer
                                        containerClass="m-2 mb-0 p-2 mt-0 rounded-bottom-only"
                                        children={<>
                                            <div className="row mb-2">
                                                <div className="col">
                                                    <button
                                                        className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                                        onClick={() => setShowPromptSettingsAdvancedCreate(!showPromptSettingsAdvancedCreate)}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={showPromptSettingsAdvancedCreate ? faChevronDown : faChevronRight}
                                                            className="me-2"
                                                        />
                                                        Advanced Settings
                                                    </button>
                                                </div>
                                                {
                                                    showPromptSettingsAdvancedCreate
                                                    ?   <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={520}
                                                                maxHeight={650}
                                                                children={<WorkLoadCreateSettingsInfoElement/>}
                                                                image={sengiInfo1}   
                                                                imageHeight={40}
                                                                imageBorder={false}
                                                            />
                                                        </div>
                                                    : <></>
                                                }
                                            </div>
                                            {
                                                showPromptSettingsAdvancedCreate
                                                ?   <>
                                                        {
                                                            aiModelList.length > 0
                                                            ?   <>
                                                                    <div className="col-auto">
                                                                        AI Model:
                                                                    </div>
                                                                    <div className="col p-0 mb-1">
                                                                        <EffectThemeDropdown className="w-100">
                                                                            <EffectThemeDropdown.Toggle
                                                                                id="dropdown-ai-model"
                                                                                className="w-100"
                                                                            >
                                                                                {inputCreate.selectedAiModel}
                                                                            </EffectThemeDropdown.Toggle>

                                                                            <EffectThemeDropdown.Menu className="p-1 w-100">
                                                                                {aiModelList.map((item, index) => (
                                                                                <EffectThemeDropdown.Item
                                                                                    key={index}
                                                                                    onClick={()=> handleDropdownChangeCreate('selectedAiModel', item)}
                                                                                    active={item === inputCreate.selectedAiModel}
                                                                                >
                                                                                    {item}
                                                                                </EffectThemeDropdown.Item>
                                                                                ))}
                                                                            </EffectThemeDropdown.Menu>
                                                                            </EffectThemeDropdown>

                                                                    </div>
                                                                </>
                                                            : <></>
                                                        }
                                                        {
                                                            samplingSteps 
                                                            ?   <>
                                                                    <div className="row m-0 p-0">
                                                                        <div className="col-auto mb-1 ps-0"> {t('label.samplingSteps')}</div>
                                                                        <div className="col">{inputCreate.samplingSteps}</div>
                                                                        <div className="col-auto mb-1 p-0">
                                                                            <InfoPopoverButton
                                                                                width={320}
                                                                                placement="right"
                                                                            >
                                                                                <SamplingStepsInfoElement/>
                                                                            </InfoPopoverButton>
                                                                        </div>
                                                                    </div>
                                                                    <EffectThemeRange
                                                                        min={1}
                                                                        max={40}
                                                                        step={1}
                                                                        name="samplingSteps"
                                                                        value={inputCreate.samplingSteps}
                                                                        onChange={val => handleRangeChangeCreate('samplingSteps', val)}
                                                                        minDescription="1 (fast)"
                                                                        maxDescription="40 (slow)"
                                                                        className="mb-2"
                                                                    />

                                                                </>
                                                            :   <></>
                                                        }
                                                        {
                                                            creativityRange 
                                                            ?   <>
                                                                    <div className="row m-0 p-0 align-items-center">
                                                                        <div className="col-auto mb-1 ps-0">
                                                                            {t('label.cfgScale')}
                                                                        </div>
                                                                        <div className="col text-end">
                                                                            {inputCreate.creativity}
                                                                        </div>
                                                                        <div className="col-auto mb-1 p-0">
                                                                            <InfoPopoverButton
                                                                                width={320}
                                                                                placement="right"
                                                                            >
                                                                                <CfgInfoElement/>
                                                                            </InfoPopoverButton>
                                                                        </div>
                                                                    </div>
                                                                    <EffectThemeRange
                                                                        min={0}
                                                                        max={20}
                                                                        step={0.1}
                                                                        name="creativity"
                                                                        value={inputCreate.creativity}
                                                                        onChange={val => handleRangeChangeCreate('creativity', val)}
                                                                        minDescription="1 (creativ)"
                                                                        maxDescription="20 (exact)"
                                                                        className="mb-2"
                                                                    />

                                                                </>
                                                            :   <></>
                                                        }
                                                        { samplerList && samplerList.length > 0
                                                            ?   <>
                                                                    <div className="row m-0 p-0">
                                                                        <div className="col-auto mb-1 ps-0">{t('label.sampler')}</div>
                                                                        <div className="col"></div>
                                                                        <div className="col-auto mb-1 p-0">
                                                                            <InfoPopoverButton
                                                                                width={320}
                                                                                placement="right"
                                                                            >
                                                                                <SamplerInfoElement/>
                                                                            </InfoPopoverButton>
                                                                        </div>
                                                                    </div>
                                                                    <EffectThemeDropdown className="w-100 mb-2">
                                                                        <EffectThemeDropdown.Toggle
                                                                            id="dropdown-sampler"
                                                                            className="w-100"
                                                                        >
                                                                            {inputCreate.sampler}
                                                                        </EffectThemeDropdown.Toggle>

                                                                        <EffectThemeDropdown.Menu className="p-1 w-100">
                                                                            {samplerList.map((item, index) => (
                                                                            <EffectThemeDropdown.Item
                                                                                key={index}
                                                                                onClick={()=> handleDropdownChangeCreate('sampler', item)}
                                                                                active={item === inputCreate.sampler}
                                                                            >
                                                                                {item}
                                                                            </EffectThemeDropdown.Item>
                                                                            ))}
                                                                        </EffectThemeDropdown.Menu>
                                                                    </EffectThemeDropdown>
                                                                </>
                                                            :   <></>
                                                        }
                                                        { schedulerList && schedulerList.length > 0
                                                            ?   <>
                                                                    <div className="row m-0 p-0">
                                                                        <div className="col-auto mb-1 ps-0">{t('label.scheduler')}</div>
                                                                        <div className="col"></div>
                                                                        <div className="col-auto mb-1 p-0">
                                                                            <InfoPopoverButton
                                                                                width={320}
                                                                                placement="right"
                                                                            >
                                                                                <SchedulerInfoElement/>
                                                                            </InfoPopoverButton>
                                                                        </div>
                                                                    </div>
                                                                    <EffectThemeDropdown className="w-100 mb-2">
                                                                        <EffectThemeDropdown.Toggle
                                                                            id="dropdown-scheduler"
                                                                            className="w-100"
                                                                        >
                                                                            {inputCreate.scheduler}
                                                                        </EffectThemeDropdown.Toggle>

                                                                        <EffectThemeDropdown.Menu className="p-1 w-100">
                                                                            {schedulerList.map((item, index) => (
                                                                            <EffectThemeDropdown.Item
                                                                                key={index}
                                                                                onClick={()=> handleDropdownChangeCreate('scheduler', item)}
                                                                                active={item === inputCreate.scheduler}
                                                                            >
                                                                                {item}
                                                                            </EffectThemeDropdown.Item>
                                                                            ))}
                                                                        </EffectThemeDropdown.Menu>
                                                                    </EffectThemeDropdown>
                                                                </>
                                                            :   <></>
                                                        }
                                                        {
                                                            seed
                                                            ?   <>
                                                                    <div className="row m-0 p-0">
                                                                        <div className="col-auto mb-1 ps-0">{t('label.seed')}</div>
                                                                        <div className="col"></div>
                                                                        <div className="col-auto mb-1 p-0">
                                                                            <InfoPopoverButton
                                                                                width={320}
                                                                                placement="right"
                                                                            >
                                                                                <SeedInfoElement/>
                                                                            </InfoPopoverButton>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row m-0 p-0">
                                                                        <div className="col ps-0">
                                                                            <EffectThemeInput
                                                                                type="number"
                                                                                name="seed"
                                                                                value={inputCreate.seed}
                                                                                min={-1}
                                                                                max={999999}
                                                                                step={1}
                                                                                inputClassName="mb-2"
                                                                                onValueChange={(v) => setInputCreate(p => ({ ...p, seed: Number(v) }))}
                                                                            />
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <button
                                                                                className="btn btn-transparent m-0 p-0"
                                                                                title={t('title.getRandomSeed')}
                                                                                onClick={(v) => setInputCreate(p => ({ ...p, seed: handleGetRandomNumber() }))}
                                                                            >
                                                                                <FontAwesomeIcon
                                                                                    icon={faDice}
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row m-0 p-0">
                                                                        <div className="ps-0">
                                                                            <Form.Check
                                                                                label={t('label.changeSeedAutoSwitch')}
                                                                                type="checkbox"
                                                                                title={t('title.randomSeedHint')}
                                                                                checked={seedRandomCreateActive}
                                                                                onChange={() => {
                                                                                    setSeedRandomCreateActive(prev => !prev);
                                                                                }}
                                                                                style={{ fontSize: 16 }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            :   <></>
                                                        }
                                                        { qualityList && qualityList.length > 0
                                                            ?   <>
                                                                    <div className="row m-0 p-0">
                                                                        <div className="col-auto mb-1 ps-0">{t('label.quality')}</div>
                                                                        <div className="col"></div>
                                                                        <div className="col-auto mb-1 p-0">
                                                                            <InfoPopoverButton
                                                                                width={320}
                                                                                placement="right"
                                                                            >
                                                                                <QualityInfoElement/>
                                                                            </InfoPopoverButton>
                                                                        </div>
                                                                    </div>
                                                                    <EffectThemeDropdown className="w-100 mb-2">
                                                                        <EffectThemeDropdown.Toggle
                                                                            id="dropdown-quality"
                                                                            className="w-100"
                                                                        >
                                                                            {inputCreate.quality}
                                                                        </EffectThemeDropdown.Toggle>

                                                                        <EffectThemeDropdown.Menu className="p-1 w-100">
                                                                            {qualityList.map((item, index) => (
                                                                            <EffectThemeDropdown.Item
                                                                                key={index}
                                                                                onClick={()=> handleDropdownChangeCreate('quality', item)}
                                                                                active={item === inputCreate.quality}
                                                                            >
                                                                                {item}
                                                                            </EffectThemeDropdown.Item>
                                                                            ))}
                                                                        </EffectThemeDropdown.Menu>
                                                                    </EffectThemeDropdown>
                                                                </>
                                                            :   <></>
                                                        }
                                                    </>
                                                :   <></>
                                            }
                                        
                                        </>}
                                    />
                                </div>
                            :   <EffectThemeContainer
                                    containerClass="row m-2 p-2 mt-0 pt-0 border rounded border-secondary align-items-center rounded-bottom-only"
                                    children={
                                        <div className="col">
                                            {
                                                historyCreate.length > 0
                                                ?   
                                                    historyCreate.map((item,index) =>(
                                                        <div className={`row p-2 text-center align-items-center history-row ${index === 0 ? '' : ' border-top border-secondary'}`}
                                                            onClick={() => {
                                                                setInputCreate(item);
                                                                setExpandImageVariationsActive(false);
                                                                if(item.generation && item.generation.length > 0){
                                                                    onItemSelect?.(index,item.generation[0])
                                                                }
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if(item.generation && item.generation.length > 0){
                                                                    onItemHover?.(item.generation[0]);
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if(item.generation && item.generation.length > 0){
                                                                    onItemHoverEnd?.(item.generation[0]);
                                                                }}}

                                                        >
                                                            <div className='col-auto'>
                                                                {item.generation && item.generation.length > 0
                                                                    ? <EffectThemeImageGrid size={'50px'} images={[item.generation[0]]} />
                                                                    : <></>
                                                                }
                                                            </div>
                                                            <div className='col justify-content-center text-start'>
                                                                <p className='mb-2'>{item.prompt_positive}</p>
                                                            </div>
                                                        </div>
                                                    ))
                                                    
                                                :   <div className="row m-2 mb-0 p-0 py-3">
                                                        <div className="col"></div>
                                                        <div className="col-auto">
                                                            <FontAwesomeIcon
                                                                icon={faFolderOpen}
                                                                size="xl"
                                                            />
                                                        </div>
                                                        <div className="col-auto h5">
                                                            Empty History
                                                        </div>
                                                        <div className="col"></div>
                                                    </div>
                                            }
                                        </div>
                                    }
                                />
                        }
                    </>
                :   <>
                        
                        {/* <EffectThemeContainer
                            containerClass="m-2 p-2 mt-0 rounded"
                            children={<>
                                <div className="mb-2">
                                    <button
                                        className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                        onClick={() => setShowUploadImageEdit(!showUploadImageEdit)}
                                    >
                                        <FontAwesomeIcon
                                            icon={showUploadImageEdit ? faChevronDown : faChevronRight}
                                            className="me-2"
                                        />
                                        Image upload
                                    </button>
                                </div>
                                {
                                    showUploadImageEdit
                                    ?   <div className="row p-0 m-0 my-2">
                                            <FileUpload
                                                accept="image/*"
                                                multiple={false}
                                                buttonText={t('button.uploadImage')}
                                                dragAndDrop={true}
                                                onFilesSelected={async (files) => {
                                                    const imageDimension = await getImageDimensions(files[0]);
                                                    const imgSrc = URL.createObjectURL(files[0]);
                                                    let newEditInput: SettingsPanelEditInputProps = {
                                                        originalImgSrc: imgSrc,
                                                        imgSrc: imgSrc,
                                                        baseImgSrc: imgSrc,
                                                        imgFile: files[0],
                                                        width: imageDimension.width,
                                                        height: imageDimension.height,
                                                        aspectRatio: '',
                                                        colorFilterName: 'No Filter',
                                                        colorFilterData: colorFilterList[0],
                                                        flipVertical: false,
                                                        flipHorizontal: false,
                                                        rotation:0,
                                                        title: files[0].name,
                                                        transparency: {
                                                            color: '#ffffff',
                                                            alpha:1.0,
                                                            tolerance: 40
                                                        },
                                                        transparencyTransition: {
                                                            color: '#ffffff',
                                                            alpha:1.0,
                                                            tolerance: 40
                                                        },
                                                        cropRect: null
                                                    };
                                                    setHistoryEdit([newEditInput]);
                                                    setInputEdit(newEditInput);
                                                    setColorFilter(colorFilterList[0]);
                                                    setShowUploadImageEdit(false);
                                                    onCreateNewBaseImageEntry(files[0])
                                                }}
                                            />
                                        </div>
                                    :   <></>
                                }
                            </>}
                        /> */}
                        <div className="row p-2 pb-0 m-0 mt-2">
                            <div className="col-6 p-0">
                                <EffectThemeButton
                                    className="btn border-secondary rounded w-100 border-bottom-0 rounded-top-only"
                                    title={t('tab.basicEdit')}
                                    active={showEditStandardFunctions}
                                    onClick={() => setShowEditStandardFunction(true)}
                                    tabPosition="left"
                                    children={<>
                                    <FontAwesomeIcon
                                        icon={faPenToSquare}
                                        className="me-2"
                                    />
                                    Basics
                                    </>}
                                />
                            </div>
                            <div className="col-6 p-0">
                                <EffectThemeButton
                                    className="btn border-secondary rounded w-100 border-bottom-0 rounded-top-only"
                                    title={t('tab.aiEdit')}
                                    active={!showEditStandardFunctions}
                                    onClick={() => setShowEditStandardFunction(false)}
                                    tabPosition="left"
                                    children={<>
                                    <FontAwesomeIcon
                                        icon={faWandMagicSparkles}
                                        className="me-2"
                                    />
                                    AI Mode
                                    </>}
                                />
                            </div>
                        </div>
                        {
                            showEditStandardFunctions
                            ?   <EffectThemeContainer
                                    containerClass="m-2 p-2 mt-0 rounded-bottom-only"
                                    children={<>
                                        <div className="row mb-2">
                                            <div className="col text-start">
                                                <button
                                                    className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                                    onClick={() => setShowImagePropsSettings(!showImagePropSettings)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={showImagePropSettings ? faChevronDown : faChevronRight}
                                                        className="me-2"
                                                    />
                                                    Base properties
                                                </button>
                                            </div>
                                            {
                                                showImagePropSettings
                                                ?   <div className='col-auto'>
                                                        <InfoPopoverButton
                                                            width={520}
                                                            maxHeight={650}
                                                            children={<WorkLoadEditStandardInfoElement/>}
                                                            image={sengiInfo3}   
                                                            imageHeight={40}
                                                            imageBorder={false}
                                                        />
                                                    </div>
                                                : <></>
                                            }
                                        </div>
                                        
                                        {
                                            
                                            showImagePropSettings
                                            ?   <>
                                                    {/* <div className="fw-bold mb-1">Aspect Ratio</div>
                                                    <EffectThemeDropdown className="w-100 mb-2">
                                                        <EffectThemeDropdown.Toggle
                                                            id="dropdown-aspect-ratio-edit"
                                                            className="w-100"
                                                        >
                                                            {inputCreate.aspectRatio}
                                                        </EffectThemeDropdown.Toggle>

                                                        <EffectThemeDropdown.Menu className="p-1 w-100">
                                                            {aspectRatioList.map((item, index) => (
                                                                <EffectThemeDropdown.Item
                                                                    key={index}
                                                                    onClick={() => {
                                                                        handleDropdownChangeCreate('aspectRatio', item);
                                                                        setInputEdit(prev => ({
                                                                            ...prev,
                                                                            aspectRatio: item
                                                                        }));
                                                                        const ratio = parsedAspectRatios[index]
                                                                        console.log(ratio, item,index)
                                                                        openAspect(ratio.value)
                                                                    }}
                                                                    active={item === inputEdit.aspectRatio}
                                                                >
                                                                    {item}
                                                                </EffectThemeDropdown.Item>
                                                            ))
                                                            }
                                                        </EffectThemeDropdown.Menu>
                                                    </EffectThemeDropdown> */}
                                                    <div className="row g-2 mb-2">
                                                        <div className="col-auto">
                                                            <div className="mb-1">
                                                                Rotate:
                                                            </div>
                                                            <div className="row g-1">
                                                                <div className="col">
                                                                    <EffectThemeInput
                                                                        type="number"
                                                                        name="rotation"
                                                                        disabled={selectedLayer ? true : false}
                                                                        value={rotationInputValue}
                                                                        onValueChange={(value) => {
                                                                            setRotationInputValue(Number(value));

                                                                            setInputEdit(prev => ({
                                                                                ...prev,
                                                                                rotation: rotationInputValue
                                                                            }));

                                                                            openRotate(rotationInputValue);
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="col-auto">
                                                                    <EffectThemeButton
                                                                        className="btn btn-outline-secondary rounded"
                                                                        title={t('title.openRotate')}
                                                                        disabled={selectedLayer ? true : false}
                                                                        onClick={() => {
                                                                            if(rotateMode){
                                                                                onToggleRotationMode?.(false)
                                                                            }
                                                                            else{
                                                                                openRotate(inputEdit.rotation)
                                                                            }
                                                                        }}
                                                                        active={rotateMode}
                                                                        children={<FontAwesomeIcon icon={faRotate}/>}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className= "mb-1"> {t('section.flip')}</div>
                                                            <div className="row g-1">
                                                                <div className="col-auto">
                                                                    <EffectThemeButton
                                                                    className="btn btn-outline-secondary rounded"
                                                                    title={t('title.flipHorizontal')}
                                                                    disabled={selectedLayer ? true : false}
                                                                    onClick={flipHorizontal}
                                                                    children={<>
                                                                        <FontAwesomeIcon icon={faArrowRightArrowLeft}/>
                                                                    </>}
                                                                />
                                                                </div>
                                                                <div className="col-auto">
                                                                    <EffectThemeButton
                                                                        className="btn btn-outline-secondary rounded"
                                                                        title={t('title.flipVertical')}
                                                                        disabled={selectedLayer ? true : false}
                                                                        onClick={flipVertical}
                                                                        children={<>
                                                                            <FontAwesomeIcon icon={faArrowRightArrowLeft} rotation={90} className="me-2" />
                                                                        </>}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className= "mb-1"> {t('section.crop')}</div>
                                                            <EffectThemeButton
                                                                className="btn btn-outline-secondary rounded"
                                                                title={t('title.crop')}
                                                                disabled={selectedLayer ? true : false}
                                                                onClick={()=>{
                                                                    if(cropMode){
                                                                        onToggleCropeMode?.(false);
                                                                    }
                                                                    else{
                                                                        openCrop();
                                                                    }
                                                                }}
                                                                active={cropMode}
                                                                children={<>
                                                                    <FontAwesomeIcon icon={faScissors}/>
                                                                </>}
                                                            />
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className="mb-1">{t('section.expand')}</div>
                                                            <EffectThemeButton 
                                                                className="btn btn-outline-secondary rounded"
                                                                title={t('title.expand')}
                                                                disabled={selectedLayer ? true : false}
                                                                onClick={() => {
                                                                    if(openExtandImage.active){
                                                                        onCancelExtendImage();
                                                                    }
                                                                    else{
                                                                        onOpenExpandBaseTransparent();
                                                                    }
                                                                }}
                                                                active={openExtandImage.active ?? false}
                                                                children={<>
                                                                    <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter}/>
                                                                </>}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="fw-bold mb-1">{t('label.colorFilter')}</div>
                                                    <EffectThemeDropdown className="w-100 mb-2">
                                                        <EffectThemeDropdown.Toggle
                                                            id="dropdown-color-filter"
                                                            className="w-100"
                                                            disabled={selectedLayer ? true : false}
                                                        >
                                                            {colorFilter.name}
                                                        </EffectThemeDropdown.Toggle>

                                                        <EffectThemeDropdown.Menu className="p-1 w-100">
                                                            {colorFilterList.map((item, index) => (
                                                            <EffectThemeDropdown.Item
                                                                key={index}
                                                                onClick={()=> addColorFilterSettingsToInput(item)}
                                                                active={item === colorFilter}
                                                            >
                                                                {item.name}
                                                            </EffectThemeDropdown.Item>
                                                            ))}
                                                        </EffectThemeDropdown.Menu>
                                                    </EffectThemeDropdown>
                                                </>
                                            :   <></>
                                        }      
                                        
                                        <div className="row mb-2">
                                            <div className="col text-start">
                                                <button
                                                    className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                                    onClick={() => setShowSpecificFilterEdit(!showSpecificFilterEdit)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={showSpecificFilterEdit ? faChevronDown : faChevronRight}
                                                        className="me-2"
                                                    />
                                                    Specific filter
                                                </button>
                                            </div>
                                        </div>   
                                        {
                                            showSpecificFilterEdit
                                            ?   <>
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.temperature')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.temperature}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<TemperatureInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="temperature"
                                                        value={inputEdit.colorFilterData.temperature}
                                                        onChange={val => applySpecificEditValue('temperature', val)}
                                                        minDescription="-100 (cold)"
                                                        maxDescription="100 (warm)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('temperature',0)}
                                                    />

                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.tint')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.tint}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<TintInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="tint"
                                                        value={inputEdit.colorFilterData.tint}
                                                        onChange={val => applySpecificEditValue('tint', val)}
                                                        minDescription="-100 (green)"
                                                        maxDescription="100 (purple)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('tint',0)}
                                                    />
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.brightness')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.brightness}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<BrightnessInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="brightness"
                                                        value={inputEdit.colorFilterData.brightness}
                                                        onChange={val => applySpecificEditValue('brightness', val)}
                                                        minDescription="-100 (dark)"
                                                        maxDescription="100 (light)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('brightness',0)}
                                                    />

                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.contrast')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.contrast}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<ContrastInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="contrast"
                                                        value={inputEdit.colorFilterData.contrast}
                                                        onChange={val => applySpecificEditValue('contrast', val)}
                                                        minDescription="-100 (low)"
                                                        maxDescription="100 (strong)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('contrast',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.highlights')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.highlights}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<HighlightsInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="highlights"
                                                        value={inputEdit.colorFilterData.highlights}
                                                        onChange={val => applySpecificEditValue('highlights', val)}
                                                        minDescription="-100 (low)"
                                                        maxDescription="100 (strong)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('highlights',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.shadow')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.shadow}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<ShadowsInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="shadow"
                                                        value={inputEdit.colorFilterData.shadow}
                                                        onChange={val => applySpecificEditValue('shadow', val)}
                                                        minDescription="-100 (more)"
                                                        maxDescription="100 (low)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('shadow',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.whiteness')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.whiteness}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<WhitenessInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="whiteness"
                                                        value={inputEdit.colorFilterData.whiteness}
                                                        onChange={val => applySpecificEditValue('whiteness', val)}
                                                        minDescription="-100 (black)"
                                                        maxDescription="100 (white)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('whiteness',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.saturation')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.saturation}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<SaturationInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="saturation"
                                                        value={inputEdit.colorFilterData.saturation}
                                                        onChange={val => applySpecificEditValue('saturation', val)}
                                                        minDescription="-100 (colorless)"
                                                        maxDescription="100 (saturated)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('saturation',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.vibrance')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.vibrance}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<VibranceInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="vibrance"
                                                        value={inputEdit.colorFilterData.vibrance}
                                                        onChange={val => applySpecificEditValue('vibrance', val)}
                                                        minDescription="-100 (colorless)"
                                                        maxDescription="100 (balanced)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('vibrance',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.sharpness')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.sharpness}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<SharpnessInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="sharpness"
                                                        value={inputEdit.colorFilterData.sharpness}
                                                        onChange={val => applySpecificEditValue('sharpness', val)}
                                                        minDescription="-100 (soft)"
                                                        maxDescription="100 (sharp)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('sharpness',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.clarity')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.clarity}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<ClarityInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="clarity"
                                                        value={inputEdit.colorFilterData.clarity}
                                                        onChange={val => applySpecificEditValue('clarity', val)}
                                                        minDescription="-100 (blurred)"
                                                        maxDescription="100 (clear)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('clarity',0)}
                                                    />
                                                    
                                                    <div className="row m-0 p-0">
                                                        <div className="col-auto mb-1 ps-0"> {t('filter.vignetting')}</div>
                                                        <div className="col">{inputEdit.colorFilterData.vignetting}</div>
                                                        <div className='col-auto'>
                                                            <InfoPopoverButton
                                                                width={320}
                                                                maxHeight={650}
                                                                children={<VignettingInfoElement/>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <EffectThemeRange
                                                        min={-100}
                                                        max={100}
                                                        step={1}
                                                        name="vignetting"
                                                        value={inputEdit.colorFilterData.vignetting}
                                                        onChange={val => applySpecificEditValue('vignetting', val)}
                                                        minDescription="-100 (light shadow border)"
                                                        maxDescription="100 (dark shadow border)"
                                                        className="mb-2"
                                                        disabled={selectedLayer ? true : false}
                                                        showValue={false}
                                                        showCenterValue
                                                        centerValue={0}
                                                        onCenterClick={() => applySpecificEditValue('vignetting',0)}
                                                    />
                                                </>
                                            :   <></>
                                        }    
                                        <div className="row mb-2">
                                            <div className="col text-start">
                                                <button
                                                    className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                                    onClick={() => setShowTransparencyEdit(!showTransparancyEdit)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={showTransparancyEdit ? faChevronDown : faChevronRight}
                                                        className="me-2"
                                                    />
                                                    Transparency
                                                </button>
                                            </div>
                                            {
                                                showTransparancyEdit
                                            ?   <div className="col-auto">
                                                    <InfoPopoverButton
                                                        width={520}
                                                        maxHeight={650}
                                                        children={<TransparencyInfoElement/>}
                                                    />
                                                </div>
                                            :   <></>
                                            }
                                            
                                        </div>
                                        {
                                            showTransparancyEdit
                                            ?   <>
                                                    <div className="mt-3 mb-2">
                                                        <div className="fw-bold mb">{t('label.total')}</div>
                                                        <div className="row g-2 align-items-end mb-1">
                                                            <div className="col-6">
                                                                <label className="form-label small ps-1 mb-0">{t('label.alpha')}</label>
                                                                <EffectThemeInput
                                                                        type="number"
                                                                        min={0}
                                                                        max={100}
                                                                        step={1}
                                                                        value={Math.round((inputEdit.transparency?.alpha ?? 1) * 100)}
                                                                        onValueChange={(value) => handleTransparencyAlphaChange(Number(value) / 100)}
                                                                        style={{height: "43px"}}
                                                                        disabled={selectedLayer ? true : false}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label className="form-label ps-1 mb-0">{t('label.color')}</label>
                                                                <EffectThemeInput
                                                                        type="color"
                                                                        value={inputEdit.transparency?.color ?? '#ffffff'}
                                                                        title={t('title.transparencyColor')}
                                                                        onValueChange={(value) => handleTransparencyColorChange(String(value))}
                                                                        style={{height: "43px"}}
                                                                        disabled={selectedLayer ? true : false}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label className="form-label mb-0"></label>
                                                                <EffectThemeButton
                                                                    className={`btn ${isPickingTransparencyColor ? "btn-primary" : "btn-outline-secondary"} rounded`}
                                                                    title={t('title.pickColor')}
                                                                    onClick={() => onToggleTransparencyColorPicker?.()}
                                                                    children={<FontAwesomeIcon icon={faEyeDropper} className="py-1" />}
                                                                    style={{height: "43px"}}
                                                                    disabled={selectedLayer ? true : false}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row m-0 p-0">
                                                            <div className="col-auto mb-1 ps-0">{t('label.colorTolerance')}</div>
                                                            <div className="col">{inputEdit.transparency?.tolerance}</div>
                                                        </div>
                                                        <EffectThemeRange
                                                            min={0}
                                                            max={150}
                                                            step={1}
                                                            name="colorTolerance"
                                                            value={inputEdit.transparency?.tolerance ?? 40}
                                                            onChange={(value) => handleTransparencyToleranceChange(Number(value))}
                                                            minDescription="0 (strict)"
                                                            maxDescription="150 (wide range)"
                                                            className="mb-2"
                                                            disabled={selectedLayer ? true : false}
                                                        />
                                                    </div>
                                                    <div className="mt-3 mb-2">
                                                        <div className="fw-bold mb">{t('label.withTransition')}</div>
                                                        <div className="row g-2 align-items-end mb-1">
                                                            <div className="col-6">
                                                                <label className="form-label small ps-1 mb-0">{t('label.alpha')}</label>
                                                                <EffectThemeInput
                                                                        type="number"
                                                                        min={0}
                                                                        max={100}
                                                                        step={1}
                                                                        value={Math.round((inputEdit.transparencyTransition?.alpha ?? 1) * 100)}
                                                                        onValueChange={(value) => handleTransparencyTransitionAlphaChange(Number(value) / 100)}
                                                                        style={{height: "43px"}}
                                                                        disabled={selectedLayer ? true : false}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label className="form-label ps-1 mb-0">{t('label.color')}</label>
                                                                <EffectThemeInput
                                                                        type="color"
                                                                        value={inputEdit.transparencyTransition?.color ?? '#ffffff'}
                                                                        title={t('title.transparencyColor')}
                                                                        onValueChange={(value) => handleTransparencyTransitionColorChange(String(value))}
                                                                        style={{height: "43px"}}
                                                                        disabled={selectedLayer ? true : false}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label className="form-label mb-0"></label>
                                                                <EffectThemeButton
                                                                    className={`btn ${isPickingTransparencyTransitionColor ? "btn-primary" : "btn-outline-secondary"} rounded`}
                                                                    title={t('title.pickColor')}
                                                                    onClick={() => onToggleTransparencyTransitionColorPicker?.()}
                                                                    children={<FontAwesomeIcon icon={faEyeDropper} className="py-1" />}
                                                                    style={{height: "43px"}}
                                                                    disabled={selectedLayer ? true : false}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row m-0 p-0">
                                                            <div className="col-auto mb-1 ps-0">{t('label.colorTolerance')}</div>
                                                            <div className="col">{inputEdit.transparencyTransition?.tolerance}</div>
                                                        </div>
                                                        <EffectThemeRange
                                                            min={0}
                                                            max={400}
                                                            step={1}
                                                            name="colorTolerance"
                                                            value={inputEdit.transparencyTransition?.tolerance ?? 40}
                                                            onChange={(value) => handleTransparencyTransitionToleranceChange(Number(value))}
                                                            minDescription="0 (strict)"
                                                            maxDescription="400 (wide range)"
                                                            className="mb-2"
                                                            disabled={selectedLayer ? true : false}
                                                        />
                                                    </div>
                                                </>
                                            :   <></>
                                        }    
                                    </>}
                                />
                            : <EffectThemeContainer
                                containerClass="m-2 p-2 mt-0 rounded"
                                children={<>
                                    <div className="row mb-2">
                                        <div className="col">
                                            <button
                                                className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                                onClick={() => setShowBasicAIFunctions(!showBasicAIFunctions)}
                                            >
                                                <FontAwesomeIcon
                                                    icon={showBasicAIFunctions ? faChevronDown : faChevronRight}
                                                    className="me-2"
                                                />
                                                Basic AI Functions
                                            </button>
                                        </div>
                                        {
                                            showBasicAIFunctions
                                            ?   <div className='col-auto'>
                                                    <InfoPopoverButton
                                                        width={520}
                                                        maxHeight={650}
                                                        children={<WorkLoadEditAIModeInfoElement/>}
                                                        image={sengiInfo4}   
                                                        imageHeight={40}
                                                        imageBorder={false}
                                                    />
                                                </div>
                                            : <></>
                                        }
                                    </div>
                                    {
                                        showBasicAIFunctions
                                        ?   <>
                                                <div className="row p-0 m-0 mt-2 align-items-center">
                                                    <div className="col">
                                                        <label htmlFor="prompt_positive" className="form-label ps-0">{positiveAndNegativePromptEdit ? t('prompt.positive') : t('prompt.promptOnly') }</label>
                                                    </div>
                                                    {
                                                        generateRandomPrompt 
                                                        ?   <div className="col-auto p-0">
                                                                <button
                                                                    title={generateRandomPromptText}
                                                                    className="btn border-0 bg-transparent w-100"
                                                                    onClick={()=>handleRandomPrompt('edit')}
                                                                    disabled={aiFunctionsAreDisabled}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={faDice}
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            position: "relative",
                                                                            top: "-5px",
                                                                            right: "-5px",
                                                                            transform: "scale(0.5)",
                                                                            pointerEvents: "none"
                                                                        }}
                                                                    >
                                                                        <FreeLogo size={12}/>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        :   <></>
                                                    }
                                                    {
                                                        checkPrompt 
                                                        ?   <div className="col-auto p-0">
                                                                <button
                                                                    title={checkPromptText}
                                                                    className="btn border-0 bg-transparent w-100"
                                                                    onClick={()=> handleCheckPrompt('edit')}
                                                                    disabled={aiFunctionsAreDisabled}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={faCheckDouble}
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            position: "relative",
                                                                            top: "-5px",
                                                                            right: "-5px",
                                                                            transform: "scale(0.5)",
                                                                            pointerEvents: "none"
                                                                        }}
                                                                    >
                                                                        <FreeLogo size={12}/>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        :   <></>
                                                    }
                                                </div>
                                                <div className='row p-0 m-0'>
                                                    <textarea
                                                        className="form-control"
                                                        id="prompt_positive"
                                                        name='prompt_positive'
                                                        rows={3}
                                                        value={inputAiEdit.prompt_positive}
                                                        onChange={(e) => setInputAiEdit(prev => ({...prev,['prompt_positive']: e.target.value}))}
                                                        placeholder={t('prompt.placeholderPositive')}
                                                    />
                                                </div>
                                                {
                                                    positiveAndNegativePromptEdit
                                                    ?   <div className='row p-0 m-0 mt-2'>
                                                            <label htmlFor="prompt_negative" className="form-label ps-0">{t('prompt.negative')}</label>
                                                            <EffectThemeTextarea
                                                                className="form-control"
                                                                id="prompt_negative"
                                                                name="prompt_negative"
                                                                rows={3}
                                                                value={inputAiEdit.prompt_negative}
                                                                onChange={(e) => setInputAiEdit(prev => ({...prev,['prompt_negative']: e.target.value}))}
                                                                placeholder={t('prompt.placeholderNegative')}
                                                            /> 
                                                        </div>
                                                    : <></>
                                                }     
                                                <div className="row p-0 m-0 mt-2">
                                                    <div className="col p-0">
                                                        <Form.Check
                                                            label={'Pos./Neg. Prompt'}
                                                            type="switch"
                                                            id="single-prompt-switch"
                                                            checked={positiveAndNegativePromptEdit}
                                                            onChange={() => setPositiveAndNegativePromptEdit(prev => !prev)}
                                                        />
                                                    </div>
                                                    <div className="col-auto mb-1 p-0">
                                                        <InfoPopoverButton
                                                            width={320}
                                                            placement="right"
                                                        >
                                                            <PositiveNegativePromptInfoElement/>
                                                        </InfoPopoverButton>
                                                    </div>
                                                </div>
                                                <div
                                                    className="row g-0 align-items-center p-2 mt-2"
                                                    style={{
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        borderRadius: 8,
                                                        border: "1px solid rgba(255,255,255,0.18)",
                                                        background: "rgba(147,129,255,0.03)",
                                                        flex: "0 0 auto"
                                                    }}
                                                >
                                                    <div className="w-100">
                                                        <div className="row">
                                                            <EffectThemeImageGrid 
                                                                size="150px"
                                                                images={aiEditPreviewImages}
                                                                objectFit="contain"
                                                                className="justify-content-start"
                                                                buttonClassname="p-2"
                                                                backgroundColor="rgba(0,0,0,0.25)"
                                                                showPlaceholder
                                                                placeholderContent={
                                                                    <div className="text-secondary">
                                                                        <FontAwesomeIcon icon={faImage} className="me-1" />
                                                                        {t('label.noImage')}
                                                                    </div>
                                                                }
                                                            />
                                                        </div>

                                                        {aiEditPreviewImages.length > 0 && (
                                                            <div className="row mt-1" >
                                                                <div
                                                                    style={{
                                                                        fontSize: 16,
                                                                        color: "#b8b8b8",
                                                                        whiteSpace: "normal",
                                                                        wordBreak: "break-word",
                                                                    }}
                                                                >
                                                                    <div className="fw-bold">
                                                                        {marqueeArea
                                                                        ? t('label.markedArea')
                                                                        : selectedLayerIDs.length > 1 && !workOnBaseImage
                                                                            ? t('label.selectedLayers')
                                                                            : selectedLayer && !workOnBaseImage
                                                                                ? t('label.selectedLayerType', { type: selectedLayer.type })
                                                                                : t('label.baseImage')}
                                                                    </div>
                                                                </div>
                                                                {/* <div className="mt-auto text-secondary">Reference:</div>
                                                                <div className="mt-1">
                                                                {(selectedLayer && selectedLayerIDs.length === 1) || layerAreaSelection 
                                                                    ?   <Form.Check
                                                                            className="ai-edit-ref-switch mb-0"
                                                                            label={t('label.useOnlyBaseImage')}
                                                                            type="switch"
                                                                            title={t('title.useBaseRef')}
                                                                            checked={switchUseBaseImageAsReferenceAiEdit}
                                                                            onChange={() => {
                                                                                let lastState = switchUseBaseImageAsReferenceAiEdit;
                                                                                setSwitchUseBaseImageAsReferenceAiEdit(!lastState);
                                                                                if(!lastState){
                                                                                    setSwitchUseAllLayersAsReferenceAiEdit(false);
                                                                                    setSwitchUseAllSelectedLayersAsReferenceAiEdit(false);
                                                                                }
                                                                            }}
                                                                            style={{ fontSize: 14 }}
                                                                        />
                                                                    :   <></>
                                                                }
                                                                { allLayer.length > 1
                                                                    ?   <Form.Check
                                                                            className="ai-edit-ref-switch mb-1"
                                                                            label={t('label.useAllLayersSwitch')}
                                                                            type="switch"
                                                                            title={t('title.useAllLayersRef')}
                                                                            checked={switchUseAllLayersAsReferenceAiEdit}
                                                                            onChange={() => {
                                                                                let lastState = switchUseAllLayersAsReferenceAiEdit;
                                                                                setSwitchUseAllLayersAsReferenceAiEdit(!lastState)
                                                                                if(!lastState){
                                                                                    setSwitchUseBaseImageAsReferenceAiEdit(false);
                                                                                    setSwitchUseAllSelectedLayersAsReferenceAiEdit(false);
                                                                                }
                                                                            }}
                                                                            style={{ fontSize: 14 }}
                                                                        />
                                                                    : <></>

                                                                }
                                                                
                                                                {workOnBaseImage && image
                                                                    ?   <Form.Check
                                                                            className="ai-edit-ref-switch mb-0"
                                                                            label={t('label.useSelectedLayersSwitch')}
                                                                            type="switch"
                                                                            title={t('title.useSelectedLayersRef')}
                                                                            checked={switchUseAllSelectedLayersAsReferenceAiEdit}
                                                                            onChange={() => {
                                                                                let lastState = switchUseAllSelectedLayersAsReferenceAiEdit;
                                                                                setSwitchUseAllSelectedLayersAsReferenceAiEdit(!lastState);
                                                                                if(!lastState){
                                                                                    setSwitchUseAllLayersAsReferenceAiEdit(false);
                                                                                    setSwitchUseBaseImageAsReferenceAiEdit(false);
                                                                                }
                                                                            }}
                                                                            style={{ fontSize: 14 }}
                                                                        />
                                                                    :   <></>
                                                                }
                                                                </div> */}
                                                            </div>
                                                        )}
                                                        {/* { image
                                                            ?   <div className="d-flex align-items-stretch gap-2 mt-2">
                                                                    <div className="flex-shrink-0">
                                                                        <Form.Check
                                                                            label={t('title.workOnBase')}
                                                                            type="checkbox"
                                                                            title={t('title.workOnBase')}
                                                                            checked={workOnBaseImage}
                                                                            onChange={() => {
                                                                                setWorkOnBaseImage(prev => !prev);
                                                                            }}
                                                                            style={{ fontSize: 16 }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            : <></>

                                                        } */}
                                                        </div>
                                                </div>
                                                { stylesList && stylesList.length > 0 && aiEditPreviewImages.length > 0
                                                    ?   <>
                                                            <div className="my-1">{t('label.style')}</div>
                                                            <EffectThemeDropdown.SearchFilter
                                                                id="dropdown-style-model-edit"
                                                                className="w-100 mb-2"
                                                                items={stylesList}
                                                                selectedLabel={stylesList.filter(x => x.item === inputAiEdit.style).length > 0 ? stylesList.filter(x => x.item === inputAiEdit.style)[0].name : ''}
                                                                onSelect={(x) => {
                                                                    setInputAiEdit(prev => ({
                                                                        ...prev,
                                                                        style: x.item
                                                                    }));
                                                                }}
                                                                getItemKey={(x) => x.item}
                                                                getItemSearchText={(x) => `${x.name ?? ""} ${x.item} ${x.category}`}
                                                                renderItem={renderStyleDropdownItem}
                                                                filterGroups={styleFilterGroups}
                                                                searchPlaceholder={t('label.searchStyle')}
                                                                resetKey={image?.src ?? "edit-without-image"}
                                                                maxHeight={420}
                                                            />
                                                        </>
                                                    :   <></>
                                                }
                                                {
                                                    numberGenerationsMax && aiEditPreviewImages.length > 0
                                                    ?   <>
                                                            <div className="row m-0 p-0">
                                                                <div className="col-auto mb-1 ps-0"> {numberOfGenerationsText}: </div>
                                                                <div className="col">{inputAiEdit.numberGenerations}</div>
                                                                <div className="col-auto mb-1 p-0">
                                                                    <InfoPopoverButton
                                                                        width={320}
                                                                        placement="right"
                                                                    >
                                                                        <NumberOfVariationsInfoElement/>
                                                                    </InfoPopoverButton>
                                                                </div>
                                                            </div>
                                                            <EffectThemeRange
                                                                min={1}
                                                                max={20}
                                                                step={1}
                                                                name="numberGenerations"
                                                                value={inputAiEdit.numberGenerations}
                                                                onChange={val => setInputAiEdit(prev => ({ ...prev, ['numberGenerations']: val }))}
                                                                minDescription="1"
                                                                maxDescription={String(20)}
                                                                className="mb-2"
                                                            />

                                                        </>
                                                    :   <></>
                                                }
                                                {
                                                    aiEditPreviewImages.length > 0
                                                    ?   <>
                                                            {/* Functions only for base image and image layer / marqued areas not for text and drawing layer */}
                                                            { marqueeArea || (((selectedLayer && (selectedLayer.type === 'image' || selectedLayer.type === 'ai-variation'))) || workOnBaseImage)
                                                                ?   <>
                                                                        <div className="row mt-2">
                                                                            <div className="col">{t('section.variationsTransform')}</div>
                                                                        </div>
                                                                        <div className="row p-0 m-0 my-2">
                                                                            <EffectThemeButton
                                                                                className="btn btn-outline-secondary rounded py-1"
                                                                                title={t('title.genVariations')}
                                                                                onClick={() => handleGenerateVariations('generateVariationsImage', workOnBaseImage ? 'base' : 'layer')}
                                                                                disabled={aiFunctionsAreDisabled}
                                                                                children={
                                                                                    <div className="row m-0 p-0">
                                                                                        <div className="col m-0 p-0">
                                                                                            <FontAwesomeIcon icon={faPlaneUp} className="me-2"/> {t('section.generateVariationsInline')} <AILogo/>
                                                                                            <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.generateVariations ?? '—'}</p>
                                                                                        </div>
                                                                                        <div className="col-auto m-0 p-0">
                                                                                            <InfoPopoverButton
                                                                                                width={320}
                                                                                                placement="right"
                                                                                            >
                                                                                                <AiGenerateVariationsInfoElement/>
                                                                                            </InfoPopoverButton>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {
                                                                            !marqueeArea
                                                                            ?   <>
                                                                                    <div className="row mt-3">
                                                                                        <div className="col-auto">{t('section.imageTools')}</div>
                                                                                        <div className="col">
                                                                                            <InfoPopoverButton
                                                                                                width={320}
                                                                                                placement="right"
                                                                                            >
                                                                                                <AiGeneralFunctionInfoElement/>
                                                                                            </InfoPopoverButton>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row p-0 m-0 my-2">
                                                                                        <EffectThemeButton
                                                                                            className="btn btn-outline-secondary rounded"
                                                                                            title={t('title.removeBackground')}
                                                                                            onClick={() => handleGenerateVariations('removeBackground', workOnBaseImage ? 'base' : 'layer')}
                                                                                            disabled={aiFunctionsAreDisabled}
                                                                                            children={
                                                                                                <>
                                                                                                    <FontAwesomeIcon icon={faXmark} className="me-2"/> {t('section.removeBackgroundInline')} <FreeLogo/>
                                                                                                </>
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <div className="row p-0 m-0 my-2">
                                                                                        <div className="col m-0 p-0">
                                                                                            <EffectThemeButton
                                                                                                className="btn btn-outline-secondary rounded py-1"
                                                                                                title={t('title.expandVariations')}
                                                                                                disabled={aiFunctionsAreDisabled}
                                                                                                onClick={() => {
                                                                                                    if (selectedLayer && selectedLayerIDs.length === 1) {
                                                                                                        onOpenExpandLayerWithVariations?.();
                                                                                                    } else {
                                                                                                        onOpenExpandBaseWithVariations?.();
                                                                                                    }
                                                                                                }}
                                                                                                children ={
                                                                                                    <div className="row m-0 p-0">
                                                                                                        <div className="col m-0 p-0">
                                                                                                            <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} className="me-2"/> {t('button.expandImage')} <BetaLogo/>
                                                                                                            <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.expand ?? '—'}</p>
                                                                                                        </div>
                                                                                                        <div className="col-auto m-0 p-0">
                                                                                                            <InfoPopoverButton
                                                                                                                width={320}
                                                                                                                placement="right"
                                                                                                            >
                                                                                                                <AiExpandImageWIthVariationsInfoElement/>
                                                                                                            </InfoPopoverButton>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                }
                                                                                            >
                                                                                            </EffectThemeButton>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            :   <></>
                                                                        }
                                                                        {/* <div className="row">
                                                                            <div className="col">Extract:</div>
                                                                            <div className="col-auto mt-1">
                                                                                <InfoPopoverButton
                                                                                    width={320}
                                                                                    placement="right"
                                                                                >
                                                                                    <AiExtractInfoElement/>
                                                                                </InfoPopoverButton>
                                                                            </div>
                                                                        </div> */}
                                                                        {/* <div className="row p-0 m-0 my-2 pb-2">
                                                                            <EffectThemeButton
                                                                                className="btn btn-outline-secondary rounded"
                                                                                title={t('title.extractPose')}
                                                                                onClick={() => handleGenerateVariations('extractPose',workOnBaseImage ? 'base' : 'layer')}
                                                                                disabled={aiFunctionsAreDisabled}
                                                                                children={
                                                                                    <>
                                                                                        <FontAwesomeIcon icon={faPerson} className="me-2"/> {t('button.pose')} <BetaLogo/>
                                                                                    </>
                                                                                }
                                                                            />
                                                                        </div> */}
                                                                        <div className="row mt-3">
                                                                            <div className="col-auto">{t('section.objectTools')}</div>
                                                                            <div className="col">
                                                                                <InfoPopoverButton
                                                                                    width={320}
                                                                                    placement="right"
                                                                                >
                                                                                    <AiObjectInfoElement/>
                                                                                </InfoPopoverButton>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row p-0 m-0 my-2">
                                                                            <EffectThemeButton
                                                                                className="btn btn-outline-secondary rounded py-1"
                                                                                title={t('title.extractObject')}
                                                                                onClick={() => handleGenerateVariations('extractObject', workOnBaseImage ? 'base' : 'layer')}
                                                                                disabled={aiFunctionsAreDisabled}
                                                                                children={
                                                                                    <>
                                                                                        <FontAwesomeIcon icon={faShapes} className="me-2"/> {t('button.extract')} <BetaLogo/>
                                                                                        <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.extractObject ?? '—'}</p>

                                                                                    </>
                                                                                }
                                                                            />
                                                                        </div>
                                                                        { marqueeArea
                                                                            ?   <>
                                                                                    <div className="row p-0 m-0 my-2">
                                                                                        <EffectThemeButton
                                                                                            className="btn btn-outline-secondary rounded py-1"
                                                                                            title={t('title.removeObject')}
                                                                                            onClick={() => handleGenerateVariations('removeObject', workOnBaseImage ? 'base' : 'layer')}
                                                                                            disabled={aiFunctionsAreDisabled}
                                                                                            children={
                                                                                                <>
                                                                                                    <FontAwesomeIcon icon={faTrash} className="me-2"/> {t('button.remove')} <BetaLogo/>
                                                                                                    <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.removeObject ?? '—'}</p>
                                                                                                </>
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <div className="row p-0 m-0 my-2">
                                                                                        <EffectThemeButton
                                                                                            className="btn btn-outline-secondary rounded py-1"
                                                                                            title={t('title.extractReplace')}
                                                                                            onClick={() => handleGenerateVariations('extractAndRemoveObject', workOnBaseImage ? 'base' : 'layer')}
                                                                                            disabled={aiFunctionsAreDisabled}
                                                                                            children={
                                                                                                <>
                                                                                                    <FontAwesomeIcon icon={faShapes} className="me-2"/> {t('button.extractRemove')} <BetaLogo/>
                                                                                                    <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.extractAndRemove ?? '—'}</p>
                                                                                                </>
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </>
                                                                            : <></>
                                                                        }
                                                                        { !marqueeArea
                                                                            ?   <>
                                                                                    <div className="row">
                                                                                        <div className="col-auto">{t('section.upscaleLabel')}</div>
                                                                                        <div className="col">
                                                                                            <InfoPopoverButton
                                                                                                width={320}
                                                                                                placement="right"
                                                                                            >
                                                                                                <AiUpscaleInfoElement/>
                                                                                            </InfoPopoverButton>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row p-0 m-0 my-2 gap-2">
                                                                                        <div className="col p-0 m-0">
                                                                                            <EffectThemeButton
                                                                                                className="btn btn-outline-secondary rounded py-1"
                                                                                                title={t('title.upscale')}
                                                                                                onClick={() => handleGenerateVariations('imageUpscale-2x', workOnBaseImage ? 'base' : 'layer')}
                                                                                                disabled={aiFunctionsAreDisabled}
                                                                                                children={
                                                                                                    <>
                                                                                                        <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} className="me-2"/> 2x <AILogo/>
                                                                                                        <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.upscale2x ?? '—'}</p>
                                                                                                    </>
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col p-0 m-0">
                                                                                            <EffectThemeButton
                                                                                                className="btn btn-outline-secondary rounded py-1"
                                                                                                title={t('title.upscale')}
                                                                                                onClick={() => handleGenerateVariations('imageUpscale-4x', workOnBaseImage ? 'base' : 'layer')}
                                                                                                disabled={aiFunctionsAreDisabled}
                                                                                                children={
                                                                                                    <>
                                                                                                        <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} className="me-2"/> 4x <AILogo/>
                                                                                                        <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.upscale4x ?? '—'}</p>
                                                                                                    </>
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            :   <></>
                                                                        }
                                                                    </>
                                                                :   <></>
                                                            }
                                                            {/* Converting to image layer only for text and drawing layer */}
                                                            { selectedLayer && (selectedLayer.type === 'text' || selectedLayer.type === 'drawings') && !workOnBaseImage && !marqueeArea
                                                                ?   <>
                                                                        <div className="row">
                                                                            <div className="col">{t('section.variationsTransform')}</div>
                                                                        </div>
                                                                        <div className={`row p-0 m-0 my-2 ${selectedLayer.type === 'drawings' ? 'pb-2' : ''}`}>
                                                                            <div className="col m-0 p-0">
                                                                                <EffectThemeButton
                                                                                    className="btn btn-outline-secondary rounded py-1"
                                                                                    title={t('title.convertToImage')}
                                                                                    onClick={() => handleGenerateVariations('convertToImage','layer')}
                                                                                    disabled={aiFunctionsAreDisabled}
                                                                                    children={
                                                                                        <div className="row m-0 p-0">
                                                                                            <div className="col m-0 p-0">
                                                                                                <FontAwesomeIcon icon={faImage} className="me-2"/> {t('button.convertToImageBtn')} <BetaLogo/>
                                                                                                <p className="text-small text-secondary m-0 p-0">{t('label.coins')}: {imageEditCosts?.convertToImage ?? '—'}</p>
                                                                                            </div>
                                                                                            <div className="col-auto m-0 p-0">
                                                                                                <InfoPopoverButton
                                                                                                    width={320}
                                                                                                    placement="right"
                                                                                                >
                                                                                                    <AiConvertToImageInfoElement/>
                                                                                                </InfoPopoverButton>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                : <></>

                                                            }
                                                            {   selectedLayer && selectedLayer.type === 'text' && !workOnBaseImage
                                                                ?   <>
                                                                        <div className="row p-0 m-0 my-2 pb-2">
                                                                            <div className="col m-0 p-0">
                                                                                <EffectThemeButton
                                                                                    className="btn btn-outline-secondary rounded"
                                                                                    title={t('title.correctSpelling')}
                                                                                    onClick={() => handleGenerateVariations('spellCorrection', 'layer')}
                                                                                    disabled={aiFunctionsAreDisabled}
                                                                                    children={
                                                                                        <div className="row m-0 p-0">
                                                                                            <div className="col m-0 p-0">
                                                                                                <FontAwesomeIcon icon={faComment} className="me-2"/> {t('section.spellCorrectionInline')} <FreeLogo/>
                                                                                            </div>
                                                                                            <div className="col-auto m-0 p-0">
                                                                                                <InfoPopoverButton
                                                                                                    width={320}
                                                                                                    placement="right"
                                                                                                >
                                                                                                    <AiSpellCorrectionInfoElement/>
                                                                                                </InfoPopoverButton>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                :   <></>

                                                            }
                                                        </>
                                                    :   <></>
                                                }
                                                
                                            </>
                                        : <></>
                                    }
                                    <div className="row mb-2">
                                        <div className="col text-start">
                                            <button
                                                className="btn btn-transparent m-0 p-0 btn-lg text-start"
                                                onClick={() => setShowSettingsAdvancedAIFunctions(!showSettingsAdvancedAIFunctions)}
                                            >
                                                <FontAwesomeIcon
                                                    icon={showSettingsAdvancedAIFunctions ? faChevronDown : faChevronRight}
                                                    className="me-2"
                                                />
                                                Advanced Settings
                                            </button>
                                        </div>
                                    </div>
                                    {
                                        showSettingsAdvancedAIFunctions
                                        ?   <>
                                                {
                                                    samplingSteps 
                                                    ?   <>
                                                            <div className="row m-0 p-0">
                                                                <div className="col-auto mb-1 ps-0"> {t('label.samplingSteps')}</div>
                                                                <div className="col">{inputAiEdit.samplingSteps}</div>
                                                                <div className="col-auto mb-1 p-0">
                                                                    <InfoPopoverButton
                                                                        width={320}
                                                                        placement="right"
                                                                    >
                                                                        <SamplingStepsInfoElement/>
                                                                    </InfoPopoverButton>
                                                                </div>
                                                            </div>
                                                            <EffectThemeRange
                                                                min={1}
                                                                max={40}
                                                                step={1}
                                                                name="samplingSteps"
                                                                value={inputAiEdit.samplingSteps}
                                                                onChange={val => {
                                                                    setInputAiEdit(prev => ({ ...prev, ['samplingSteps']: val }));
                                                                }}
                                                                minDescription="1"
                                                                maxDescription="40 (slow)"
                                                                className="mb-2"
                                                            />

                                                        </>
                                                    :   <></>
                                                }
                                                {
                                                    creativityRange 
                                                    ?   <>
                                                            <div className="row m-0 p-0">
                                                                <div className="col-auto mb-1 ps-0"> {t('label.cfgScale')} </div>
                                                                <div className="col">{inputAiEdit.creativity}</div>
                                                                <div className="col-auto mb-1 p-0">
                                                                    <InfoPopoverButton
                                                                        width={320}
                                                                        placement="right"
                                                                    >
                                                                        <CfgInfoElement/>
                                                                    </InfoPopoverButton>
                                                                </div>
                                                            </div>
                                                            <EffectThemeRange
                                                                min={0}
                                                                max={20}
                                                                step={0.1}
                                                                name="creativity"
                                                                value={inputAiEdit.creativity}
                                                                onChange={val => {
                                                                    setInputAiEdit(prev => ({ ...prev, ['creativity']: val }));
                                                                }}
                                                                minDescription="1 (creativ)"
                                                                maxDescription="20 (exact)"
                                                                className="mb-2"
                                                            />

                                                        </>
                                                    :   <></>
                                                }
                                                { samplerList && samplerList.length > 0
                                                    ?   <>
                                                            <div className="row m-0 p-0">
                                                                <div className="col-auto mb-1 ps-0">{t('label.sampler')}</div>
                                                                <div className="col"></div>
                                                                <div className="col-auto mb-1 p-0">
                                                                    <InfoPopoverButton
                                                                        width={320}
                                                                        placement="right"
                                                                    >
                                                                        <SamplerInfoElement/>
                                                                    </InfoPopoverButton>
                                                                </div>
                                                            </div>
                                                            <EffectThemeDropdown className="w-100 mb-2">
                                                                <EffectThemeDropdown.Toggle
                                                                    id="dropdown-sampler-ai-edit"
                                                                    className="w-100"
                                                                >
                                                                    {inputAiEdit.sampler}
                                                                </EffectThemeDropdown.Toggle>

                                                                <EffectThemeDropdown.Menu className="p-1 w-100">
                                                                    {samplerList.map((item, index) => (
                                                                    <EffectThemeDropdown.Item
                                                                        key={index}
                                                                        onClick={() => {
                                                                            setInputAiEdit(prev => ({ ...prev, ['sampler']: item }));
                                                                        }}
                                                                        active={item === inputAiEdit.sampler}
                                                                    >
                                                                        {item}
                                                                    </EffectThemeDropdown.Item>
                                                                    ))}
                                                                </EffectThemeDropdown.Menu>
                                                            </EffectThemeDropdown>
                                                        </>
                                                    :   <></>
                                                }
                                                { schedulerList && schedulerList.length > 0
                                                    ?   <>
                                                            <div className="row m-0 p-0">
                                                                <div className="col-auto mb-1 ps-0">{t('label.scheduler')}</div>
                                                                <div className="col"></div>
                                                                <div className="col-auto mb-1 p-0">
                                                                    <InfoPopoverButton
                                                                        width={320}
                                                                        placement="right"
                                                                    >
                                                                        <SchedulerInfoElement/>
                                                                    </InfoPopoverButton>
                                                                </div>
                                                            </div>
                                                            <EffectThemeDropdown className="w-100 mb-2">
                                                                <EffectThemeDropdown.Toggle
                                                                    id="dropdown-scheduler-ai-edit"
                                                                    className="w-100"
                                                                >
                                                                    {inputAiEdit.scheduler}
                                                                </EffectThemeDropdown.Toggle>

                                                                <EffectThemeDropdown.Menu className="p-1 w-100">
                                                                    {schedulerList.map((item, index) => (
                                                                    <EffectThemeDropdown.Item
                                                                        key={index}
                                                                        onClick={()=> {
                                                                            setInputAiEdit(prev => ({ ...prev, ['scheduler']: item }));
                                                                        }}
                                                                        active={item === inputAiEdit.scheduler}
                                                                    >
                                                                        {item}
                                                                    </EffectThemeDropdown.Item>
                                                                    ))}
                                                                </EffectThemeDropdown.Menu>
                                                            </EffectThemeDropdown>
                                                        </>
                                                    :   <></>
                                                }
                                                {
                                                    seed
                                                    ?   <>
                                                            <div className="row m-0 p-0">
                                                                <div className="col-auto mb-1 ps-0">{t('label.seed')}</div>
                                                                <div className="col"></div>
                                                                <div className="col-auto mb-1 p-0">
                                                                    <InfoPopoverButton
                                                                        width={320}
                                                                        placement="right"
                                                                    >
                                                                        <SeedInfoElement/>
                                                                    </InfoPopoverButton>
                                                                </div>
                                                            </div>
                                                            <div className="row m-0 p-0">
                                                                <div className="col ps-0">
                                                                    <EffectThemeInput
                                                                        type="number"
                                                                        name="seed"
                                                                        value={inputAiEdit.seed}
                                                                        min={-1}
                                                                        max={999999}
                                                                        step={1}
                                                                        inputClassName="mb-2"
                                                                        onValueChange={val => {
                                                                            setInputAiEdit(prev => ({ ...prev, ['seed']: Number(val) }));
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="col-auto">
                                                                    <button
                                                                        className="btn btn-transparent m-0 p-0"
                                                                        title={t('title.getRandomSeed')}
                                                                        onClick={() => setInputAiEdit(p => ({ ...p, seed: handleGetRandomNumber() }))}
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={faDice}
                                                                        />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="row m-0 p-0">
                                                                <div className="ps-0">
                                                                    <Form.Check
                                                                        label={t('label.changeSeedAutoSwitch')}
                                                                        type="checkbox"
                                                                        title={t('title.randomSeedHint')}
                                                                        checked={seedRandomEditActive}
                                                                        onChange={() => {
                                                                            setSeedRandomEditActive(prev => !prev);
                                                                        }}
                                                                        style={{ fontSize: 16 }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </>
                                                    :   <></>
                                                }
                                            </>
                                        :   <></>
                                    }
                                </>}
                            />
                        }
                </>
            }
        </>);
    return [overlayRect, setOverlayRect,activeOverlayBaseRect, rectToVisibleCanvasCrop, runGeometryEdit,settingsSideBar,workOnBaseImage, setWorkOnBaseImage,expandImageVariationsActive,setExpandImageVariationsActive, flipHorizontal,flipVertical, openCrop,aiGenerationsState,imageEditCosts,handleGenerateVariations]
};